webpackJsonp([1],{

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52186acf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58962b26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(235),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    staticClass: "treeclass"
  })
},staticRenderFns: []}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selected) ? _c('div', {
    staticClass: "ui basic segment",
    class: {
      loading: _vm.loading
    }
  }, [_c('div', {
    staticClass: "ui stackable two column grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui rounded fluid image"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }), (_vm.imageUrl) ? _c('div', {
    staticClass: "ui bottom attached label"
  }, [_vm._v(_vm._s(_vm.info ? (_vm.info.imageCaption ? _vm.info.imageCaption : _vm.selected) : 'No caption found.'))]) : _vm._e()])]), _c('div', {
    staticClass: "column",
    style: ([_vm.imageUrl ? '' : 'two wide'])
  }, [(_vm.text) ? _c('p', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), (!_vm.text) ? _c('p', [_vm._v("No Wikipedia article found for "), _c('b', [_vm._v(_vm._s(_vm.selected) + " 😢")])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tree', {
    staticClass: "tree",
    attrs: {
      "data": _vm.treeData,
      "layoutType": "radial",
      "type": "cluster",
      "duration": 50,
      "nodeText": "name",
      "margin-x": 0,
      "margin-y": 0,
      "person": _vm.selectedPerson,
      "ramp": "interpolateYlGnBu",
      "data-step": "2",
      "data-intro": "This is a phylogeny of all bird families.\n You can click on the names to learn more about them! Try it!"
    },
    on: {
      "clicked": _vm.clicked
    }
  }), _c('div', {
    staticClass: "ui raised container segment"
  }, [_c('my-header', {
    attrs: {
      "main": _vm.selectedLeaf ? _vm.selectedLeaf : 'Select a familiy to begin!',
      "sub": _vm.common
    }
  }), (_vm.selectedTree === 'bird') ? _c('div', {
    staticClass: "ui divider"
  }) : _vm._e(), (_vm.selectedTree === 'bird') ? _c('table', {
    staticClass: "ui center aligned single line table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Total in Family")]), _c('th', {
    class: [_vm.selectedPerson == 'corey' ? 'positive' : ''],
    attrs: {
      "data-step": "4",
      "data-intro": "You can color the tips by the proportion of bird species seen in that family!"
    },
    on: {
      "click": function($event) {
        _vm.recolor('corey')
      }
    }
  }, [_vm._v("Corey ")]), _c('th', {
    class: [_vm.selectedPerson == 'jim' ? 'positive' : ''],
    on: {
      "click": function($event) {
        _vm.recolor('jim')
      }
    }
  }, [_vm._v("Jim")]), _c('th', {
    class: [_vm.selectedPerson == 'will' ? 'positive' : ''],
    on: {
      "click": function($event) {
        _vm.recolor('will')
      }
    }
  }, [_vm._v("Will")])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.people.sp_count))]), _c('td', [_vm._v(_vm._s(_vm.people.corey))]), _c('td', [_vm._v(_vm._s(_vm.people.jim))]), _c('td', [_vm._v(_vm._s(_vm.people.will))])])])]) : _vm._e(), (_vm.selectedLeaf) ? _c('div', {
    staticClass: "ui horizontal divider",
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Summary")]) : _vm._e(), _c('wiki-summary', {
    attrs: {
      "selected": _vm.selectedLeaf
    }
  })], 1), _c('attribution')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "blank"
    }
  }, [_c('h2', {
    staticClass: "ui center aligned header"
  }, [_vm._v(_vm._s(_vm.main)), _c('div', {
    staticClass: "sub header"
  }, [_vm._v(_vm._s(_vm.sub))])])])
},staticRenderFns: []}

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui secondary menu"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "right menu"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.tutorial
    }
  }, [_vm._v("Tutorial")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#attribution'),
      expression: "'#attribution'"
    }],
    staticClass: "ui basic button",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])])])])]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container",
    attrs: {
      "data-intro": "Welcome to the Family Birding!"
    }
  }, [_c('h1', {
    attrs: {
      "id": "masthead"
    }
  }, [_vm._v("Family Birding!")])])
}]}

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui one column wide center aligned page padded grid",
    attrs: {
      "id": "attribution"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui horizontal divider"
  }, [_vm._v("Attribution")]), _c('p', [_vm._v("Text and Images: "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Main_Page"
    }
  }, [_vm._v("Wikipedia,  ")]), _vm._v("Trees: "), _c('a', {
    attrs: {
      "href": "http://birdtree.org/"
    }
  }, [_vm._v("Birds")])]), _c('p', [_vm._v("Inspired by: "), _c('a', {
    attrs: {
      "href": "https://bl.ocks.org/mbostock/c034d66572fd6bd6815a"
    }
  }, [_vm._v("Tree of Life")])]), _c('div', {
    staticClass: "ui horizontal divider"
  }, [_vm._v("Made by:")]), _c('p', [_vm._v("Developer: "), _c('a', {
    attrs: {
      "href": "http://johnwilshire.github.io/"
    }
  }, [_vm._v("John Wilshire")]), _vm._v(", Corey Callaghan, Will Cornwell")])])])
}]}

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('my-menu'), _c('phylo-tree')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

module.exports = [{"Family":"Acanthizidae","seen_count":25},{"Family":"Accipitridae","seen_count":39},{"Family":"Acrocephalidae","seen_count":1},{"Family":"Aegithalidae","seen_count":1},{"Family":"Aegothelidae","seen_count":1},{"Family":"Alaudidae","seen_count":3},{"Family":"Alcedinidae","seen_count":12},{"Family":"Alcidae","seen_count":8},{"Family":"Anatidae","seen_count":59},{"Family":"Anhingidae","seen_count":2},{"Family":"Anseranatidae","seen_count":1},{"Family":"Apodidae","seen_count":10},{"Family":"Aramidae","seen_count":1},{"Family":"Ardeidae","seen_count":24},{"Family":"Artamidae","seen_count":5},{"Family":"Bombycillidae","seen_count":2},{"Family":"Bucconidae","seen_count":1},{"Family":"Burhinidae","seen_count":2},{"Family":"Cacatuidae","seen_count":9},{"Family":"Calcariidae","seen_count":4},{"Family":"Campephagidae","seen_count":7},{"Family":"Capitonidae","seen_count":1},{"Family":"Caprimulgidae","seen_count":9},{"Family":"Cardinalidae","seen_count":20},{"Family":"Casuariidae","seen_count":2},{"Family":"Cathartidae","seen_count":3},{"Family":"Certhiidae","seen_count":1},{"Family":"Charadriidae","seen_count":20},{"Family":"Ciconiidae","seen_count":2},{"Family":"Cinclidae","seen_count":1},{"Family":"Cisticolidae","seen_count":1},{"Family":"Climacteridae","seen_count":3},{"Family":"Columbidae","seen_count":33},{"Family":"Coraciidae","seen_count":1},{"Family":"Corcoracidae","seen_count":2},{"Family":"Corvidae","seen_count":21},{"Family":"Cotingidae","seen_count":3},{"Family":"Cracidae","seen_count":4},{"Family":"Cracticidae","seen_count":6},{"Family":"Cuculidae","seen_count":17},{"Family":"Dasyornithidae","seen_count":1},{"Family":"Dicaeidae","seen_count":1},{"Family":"Dicruridae","seen_count":1},{"Family":"Diomedeidae","seen_count":3},{"Family":"Emberizidae","seen_count":47},{"Family":"Estrildidae","seen_count":10},{"Family":"Falconidae","seen_count":12},{"Family":"Falcunculidae","seen_count":1},{"Family":"Formicariidae","seen_count":1},{"Family":"Fregatidae","seen_count":2},{"Family":"Fringillidae","seen_count":21},{"Family":"Furnariidae","seen_count":12},{"Family":"Galbulidae","seen_count":1},{"Family":"Gaviidae","seen_count":2},{"Family":"Glareolidae","seen_count":1},{"Family":"Gruidae","seen_count":3},{"Family":"Haematopodidae","seen_count":4},{"Family":"Hirundinidae","seen_count":16},{"Family":"Hydrobatidae","seen_count":3},{"Family":"Icteridae","seen_count":32},{"Family":"Jacanidae","seen_count":3},{"Family":"Laniidae","seen_count":2},{"Family":"Laridae","seen_count":44},{"Family":"Locustellidae","seen_count":4},{"Family":"Machaerirhynchidae","seen_count":1},{"Family":"Maluridae","seen_count":7},{"Family":"Megapodiidae","seen_count":2},{"Family":"Meliphagidae","seen_count":41},{"Family":"Menuridae","seen_count":2},{"Family":"Meropidae","seen_count":1},{"Family":"Mimidae","seen_count":10},{"Family":"Momotidae","seen_count":4},{"Family":"Monarchidae","seen_count":9},{"Family":"Motacillidae","seen_count":3},{"Family":"Muscicapidae","seen_count":1},{"Family":"Nectariniidae","seen_count":1},{"Family":"Neosittidae","seen_count":1},{"Family":"Nyctibiidae","seen_count":1},{"Family":"Odontophoridae","seen_count":4},{"Family":"Oriolidae","seen_count":3},{"Family":"Orthonychidae","seen_count":2},{"Family":"Otididae","seen_count":1},{"Family":"Pachycephalidae","seen_count":7},{"Family":"Pandionidae","seen_count":1},{"Family":"Paradisaeidae","seen_count":2},{"Family":"Paradoxornithidae","seen_count":1},{"Family":"Pardalotidae","seen_count":2},{"Family":"Paridae","seen_count":10},{"Family":"Parulidae","seen_count":56},{"Family":"Passeridae","seen_count":2},{"Family":"Pelecanidae","seen_count":3},{"Family":"Petroicidae","seen_count":11},{"Family":"Peucedramidae","seen_count":1},{"Family":"Phaethontidae","seen_count":1},{"Family":"Phalacrocoracidae","seen_count":7},{"Family":"Phasianidae","seen_count":9},{"Family":"Phoenicopteridae","seen_count":1},{"Family":"Picidae","seen_count":26},{"Family":"Pipridae","seen_count":5},{"Family":"Pittidae","seen_count":1},{"Family":"Podargidae","seen_count":3},{"Family":"Podicipedidae","seen_count":10},{"Family":"Polioptilidae","seen_count":5},{"Family":"Pomatostomidae","seen_count":2},{"Family":"Procellariidae","seen_count":16},{"Family":"Psittacidae","seen_count":13},{"Family":"Psittaculidae","seen_count":17},{"Family":"Psophodidae","seen_count":1},{"Family":"Ptiliogonatidae","seen_count":3},{"Family":"Ptilonorhynchidae","seen_count":7},{"Family":"Pycnonotidae","seen_count":1},{"Family":"Rallidae","seen_count":20},{"Family":"Ramphastidae","seen_count":3},{"Family":"Recurvirostridae","seen_count":4},{"Family":"Regulidae","seen_count":2},{"Family":"Remizidae","seen_count":1},{"Family":"Rhipiduridae","seen_count":4},{"Family":"Scolopacidae","seen_count":46},{"Family":"Sittidae","seen_count":4},{"Family":"Steatornithidae","seen_count":1},{"Family":"Stercorariidae","seen_count":4},{"Family":"Strigidae","seen_count":17},{"Family":"Sturnidae","seen_count":3},{"Family":"Sulidae","seen_count":5},{"Family":"Thamnophilidae","seen_count":11},{"Family":"Thraupidae","seen_count":41},{"Family":"Threskiornithidae","seen_count":9},{"Family":"Tityridae","seen_count":4},{"Family":"Trochilidae","seen_count":41},{"Family":"Troglodytidae","seen_count":19},{"Family":"Trogonidae","seen_count":7},{"Family":"Turdidae","seen_count":25},{"Family":"Turnicidae","seen_count":1},{"Family":"Tyrannidae","seen_count":65},{"Family":"Tytonidae","seen_count":3},{"Family":"Vireonidae","seen_count":18},{"Family":"Zosteropidae","seen_count":1}]

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports = [{"Family":"Accipitridae","seen_count":15},{"Family":"Aegithalidae","seen_count":1},{"Family":"Alaudidae","seen_count":1},{"Family":"Alcedinidae","seen_count":1},{"Family":"Alcidae","seen_count":7},{"Family":"Anatidae","seen_count":42},{"Family":"Apodidae","seen_count":4},{"Family":"Ardeidae","seen_count":13},{"Family":"Bombycillidae","seen_count":2},{"Family":"Calcariidae","seen_count":2},{"Family":"Caprimulgidae","seen_count":3},{"Family":"Cardinalidae","seen_count":12},{"Family":"Cathartidae","seen_count":2},{"Family":"Certhiidae","seen_count":1},{"Family":"Charadriidae","seen_count":9},{"Family":"Columbidae","seen_count":6},{"Family":"Corvidae","seen_count":9},{"Family":"Cuculidae","seen_count":3},{"Family":"Diomedeidae","seen_count":1},{"Family":"Emberizidae","seen_count":30},{"Family":"Estrildidae","seen_count":1},{"Family":"Falconidae","seen_count":5},{"Family":"Fregatidae","seen_count":1},{"Family":"Fringillidae","seen_count":12},{"Family":"Gaviidae","seen_count":3},{"Family":"Gruidae","seen_count":1},{"Family":"Haematopodidae","seen_count":1},{"Family":"Hirundinidae","seen_count":8},{"Family":"Hydrobatidae","seen_count":6},{"Family":"Icteridae","seen_count":18},{"Family":"Laniidae","seen_count":2},{"Family":"Laridae","seen_count":30},{"Family":"Mimidae","seen_count":6},{"Family":"Motacillidae","seen_count":2},{"Family":"Odontophoridae","seen_count":2},{"Family":"Pandionidae","seen_count":1},{"Family":"Paradoxornithidae","seen_count":1},{"Family":"Paridae","seen_count":7},{"Family":"Parulidae","seen_count":43},{"Family":"Passeridae","seen_count":1},{"Family":"Pelecanidae","seen_count":2},{"Family":"Phaethontidae","seen_count":1},{"Family":"Phalacrocoracidae","seen_count":5},{"Family":"Phasianidae","seen_count":4},{"Family":"Picidae","seen_count":17},{"Family":"Ploceidae","seen_count":1},{"Family":"Podicipedidae","seen_count":6},{"Family":"Polioptilidae","seen_count":3},{"Family":"Procellariidae","seen_count":7},{"Family":"Psittacidae","seen_count":4},{"Family":"Ptiliogonatidae","seen_count":1},{"Family":"Rallidae","seen_count":5},{"Family":"Recurvirostridae","seen_count":2},{"Family":"Regulidae","seen_count":2},{"Family":"Remizidae","seen_count":1},{"Family":"Scolopacidae","seen_count":34},{"Family":"Sittidae","seen_count":3},{"Family":"Stercorariidae","seen_count":4},{"Family":"Strigidae","seen_count":10},{"Family":"Sturnidae","seen_count":1},{"Family":"Sulidae","seen_count":3},{"Family":"Threskiornithidae","seen_count":3},{"Family":"Trochilidae","seen_count":7},{"Family":"Troglodytidae","seen_count":10},{"Family":"Turdidae","seen_count":11},{"Family":"Tyrannidae","seen_count":26},{"Family":"Tytonidae","seen_count":1},{"Family":"Vireonidae","seen_count":10}]

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports = [{"Family":"Acanthizidae","seen_count":7},{"Family":"Accipitridae","seen_count":21},{"Family":"Acrocephalidae","seen_count":2},{"Family":"Alaudidae","seen_count":1},{"Family":"Alcedinidae","seen_count":8},{"Family":"Anatidae","seen_count":33},{"Family":"Anhingidae","seen_count":1},{"Family":"Anseranatidae","seen_count":1},{"Family":"Apodidae","seen_count":6},{"Family":"Ardeidae","seen_count":16},{"Family":"Artamidae","seen_count":3},{"Family":"Bombycillidae","seen_count":1},{"Family":"Bucerotidae","seen_count":1},{"Family":"Cacatuidae","seen_count":7},{"Family":"Campephagidae","seen_count":3},{"Family":"Casuariidae","seen_count":2},{"Family":"Cathartidae","seen_count":2},{"Family":"Certhiidae","seen_count":1},{"Family":"Charadriidae","seen_count":9},{"Family":"Ciconiidae","seen_count":3},{"Family":"Cinclidae","seen_count":1},{"Family":"Cisticolidae","seen_count":2},{"Family":"Climacteridae","seen_count":2},{"Family":"Columbidae","seen_count":17},{"Family":"Coraciidae","seen_count":2},{"Family":"Corcoracidae","seen_count":1},{"Family":"Corvidae","seen_count":12},{"Family":"Cotingidae","seen_count":1},{"Family":"Cracticidae","seen_count":5},{"Family":"Cuculidae","seen_count":3},{"Family":"Dicruridae","seen_count":2},{"Family":"Diomedeidae","seen_count":3},{"Family":"Emberizidae","seen_count":12},{"Family":"Estrildidae","seen_count":3},{"Family":"Eurypygidae","seen_count":1},{"Family":"Falconidae","seen_count":5},{"Family":"Falcunculidae","seen_count":1},{"Family":"Fringillidae","seen_count":8},{"Family":"Galbulidae","seen_count":1},{"Family":"Gaviidae","seen_count":1},{"Family":"Gruidae","seen_count":2},{"Family":"Haematopodidae","seen_count":3},{"Family":"Hirundinidae","seen_count":10},{"Family":"Icteridae","seen_count":6},{"Family":"Jacanidae","seen_count":1},{"Family":"Laniidae","seen_count":1},{"Family":"Laridae","seen_count":21},{"Family":"Leiothrichidae","seen_count":2},{"Family":"Locustellidae","seen_count":1},{"Family":"Maluridae","seen_count":3},{"Family":"Megalaimidae","seen_count":1},{"Family":"Megapodiidae","seen_count":2},{"Family":"Meliphagidae","seen_count":20},{"Family":"Menuridae","seen_count":2},{"Family":"Meropidae","seen_count":2},{"Family":"Mimidae","seen_count":1},{"Family":"Monarchidae","seen_count":4},{"Family":"Motacillidae","seen_count":3},{"Family":"Muscicapidae","seen_count":3},{"Family":"Nectariniidae","seen_count":2},{"Family":"Odontophoridae","seen_count":1},{"Family":"Opisthocomidae","seen_count":1},{"Family":"Oriolidae","seen_count":2},{"Family":"Pachycephalidae","seen_count":4},{"Family":"Pandionidae","seen_count":1},{"Family":"Pardalotidae","seen_count":1},{"Family":"Paridae","seen_count":4},{"Family":"Parulidae","seen_count":2},{"Family":"Passeridae","seen_count":2},{"Family":"Pelecanidae","seen_count":2},{"Family":"Petroicidae","seen_count":6},{"Family":"Phalacrocoracidae","seen_count":7},{"Family":"Phasianidae","seen_count":2},{"Family":"Phoenicopteridae","seen_count":1},{"Family":"Phylloscopidae","seen_count":2},{"Family":"Picidae","seen_count":5},{"Family":"Pittidae","seen_count":1},{"Family":"Podargidae","seen_count":1},{"Family":"Podicipedidae","seen_count":6},{"Family":"Procellariidae","seen_count":2},{"Family":"Prunellidae","seen_count":1},{"Family":"Psittacidae","seen_count":1},{"Family":"Psittaculidae","seen_count":12},{"Family":"Psophodidae","seen_count":1},{"Family":"Ptilonorhynchidae","seen_count":3},{"Family":"Pycnonotidae","seen_count":2},{"Family":"Rallidae","seen_count":7},{"Family":"Ramphastidae","seen_count":2},{"Family":"Recurvirostridae","seen_count":4},{"Family":"Regulidae","seen_count":1},{"Family":"Rhipiduridae","seen_count":4},{"Family":"Scolopacidae","seen_count":12},{"Family":"Sittidae","seen_count":1},{"Family":"Spheniscidae","seen_count":1},{"Family":"Strigidae","seen_count":2},{"Family":"Strigopidae","seen_count":1},{"Family":"Sturnidae","seen_count":7},{"Family":"Sulidae","seen_count":2},{"Family":"Sylviidae","seen_count":2},{"Family":"Threskiornithidae","seen_count":7},{"Family":"Trochilidae","seen_count":2},{"Family":"Troglodytidae","seen_count":2},{"Family":"Trogonidae","seen_count":1},{"Family":"Turdidae","seen_count":5},{"Family":"Tyrannidae","seen_count":3},{"Family":"Upupidae","seen_count":1},{"Family":"Vireonidae","seen_count":1},{"Family":"Zosteropidae","seen_count":1}]

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports = [{"Order":"Accipitriformes","Family":"Accipitridae (Hawks, Eagles, and Kites)","sp_count":246,"fam":"Accipitridae"},{"Order":"Accipitriformes","Family":"Cathartidae (New World Vultures)","sp_count":7,"fam":"Cathartidae"},{"Order":"Accipitriformes","Family":"Pandionidae (Osprey)","sp_count":1,"fam":"Pandionidae"},{"Order":"Accipitriformes","Family":"Sagittariidae (Secretary-bird)","sp_count":1,"fam":"Sagittariidae"},{"Order":"Anseriformes","Family":"Anatidae (Ducks, Geese, and Waterfowl)","sp_count":164,"fam":"Anatidae"},{"Order":"Anseriformes","Family":"Anhimidae (Screamers)","sp_count":3,"fam":"Anhimidae"},{"Order":"Anseriformes","Family":"Anseranatidae (Magpie Goose)","sp_count":1,"fam":"Anseranatidae"},{"Order":"Apterygiformes","Family":"Apterygidae (Kiwis)","sp_count":5,"fam":"Apterygidae"},{"Order":"Bucerotiformes","Family":"Bucerotidae (Hornbills)","sp_count":59,"fam":"Bucerotidae"},{"Order":"Bucerotiformes","Family":"Bucorvidae (Ground-Hornbills)","sp_count":2,"fam":"Bucorvidae"},{"Order":"Bucerotiformes","Family":"Phoeniculidae (Woodhoopoes and Scimitar-bills)","sp_count":8,"fam":"Phoeniculidae"},{"Order":"Bucerotiformes","Family":"Upupidae (Hoopoes)","sp_count":2,"fam":"Upupidae"},{"Order":"Caprimulgiformes","Family":"Aegothelidae (Owlet-nightjars)","sp_count":10,"fam":"Aegothelidae"},{"Order":"Caprimulgiformes","Family":"Apodidae (Swifts)","sp_count":105,"fam":"Apodidae"},{"Order":"Caprimulgiformes","Family":"Caprimulgidae (Nightjars and Allies)","sp_count":98,"fam":"Caprimulgidae"},{"Order":"Caprimulgiformes","Family":"Hemiprocnidae (Treeswifts)","sp_count":4,"fam":"Hemiprocnidae"},{"Order":"Caprimulgiformes","Family":"Nyctibiidae (Potoos)","sp_count":7,"fam":"Nyctibiidae"},{"Order":"Caprimulgiformes","Family":"Podargidae (Frogmouths)","sp_count":15,"fam":"Podargidae"},{"Order":"Caprimulgiformes","Family":"Steatornithidae (Oilbird)","sp_count":1,"fam":"Steatornithidae"},{"Order":"Caprimulgiformes","Family":"Trochilidae (Hummingbirds)","sp_count":343,"fam":"Trochilidae"},{"Order":"Cariamiformes","Family":"Cariamidae (Seriemas)","sp_count":2,"fam":"Cariamidae"},{"Order":"Casuariiformes","Family":"Casuariidae (Cassowaries and Emu)","sp_count":4,"fam":"Casuariidae"},{"Order":"Charadriiformes","Family":"Alcidae (Auks, Murres, and Puffins)","sp_count":25,"fam":"Alcidae"},{"Order":"Charadriiformes","Family":"Burhinidae (Thick-knees)","sp_count":10,"fam":"Burhinidae"},{"Order":"Charadriiformes","Family":"Charadriidae (Plovers and Lapwings)","sp_count":67,"fam":"Charadriidae"},{"Order":"Charadriiformes","Family":"Chionidae (Sheathbills)","sp_count":2,"fam":"Chionidae"},{"Order":"Charadriiformes","Family":"Dromadidae (Crab Plover)","sp_count":1,"fam":"Dromadidae"},{"Order":"Charadriiformes","Family":"Glareolidae (Pratincoles and Coursers)","sp_count":17,"fam":"Glareolidae"},{"Order":"Charadriiformes","Family":"Haematopodidae (Oystercatchers)","sp_count":12,"fam":"Haematopodidae"},{"Order":"Charadriiformes","Family":"Ibidorhynchidae (Ibisbill)","sp_count":1,"fam":"Ibidorhynchidae"},{"Order":"Charadriiformes","Family":"Jacanidae (Jacanas)","sp_count":8,"fam":"Jacanidae"},{"Order":"Charadriiformes","Family":"Laridae (Gulls, Terns, and Skimmers)","sp_count":99,"fam":"Laridae"},{"Order":"Charadriiformes","Family":"Pedionomidae (Plains-wanderer)","sp_count":1,"fam":"Pedionomidae"},{"Order":"Charadriiformes","Family":"Pluvianellidae (Magellanic Plover)","sp_count":1,"fam":"Pluvianellidae"},{"Order":"Charadriiformes","Family":"Pluvianidae (Egyptian Plover)","sp_count":1,"fam":"Pluvianidae"},{"Order":"Charadriiformes","Family":"Recurvirostridae (Stilts and Avocets)","sp_count":9,"fam":"Recurvirostridae"},{"Order":"Charadriiformes","Family":"Rostratulidae (Painted-Snipes)","sp_count":3,"fam":"Rostratulidae"},{"Order":"Charadriiformes","Family":"Scolopacidae (Sandpipers and Allies)","sp_count":97,"fam":"Scolopacidae"},{"Order":"Charadriiformes","Family":"Stercorariidae (Skuas and Jaegers)","sp_count":7,"fam":"Stercorariidae"},{"Order":"Charadriiformes","Family":"Thinocoridae (Seedsnipes)","sp_count":4,"fam":"Thinocoridae"},{"Order":"Charadriiformes","Family":"Turnicidae (Buttonquail)","sp_count":16,"fam":"Turnicidae"},{"Order":"Ciconiiformes","Family":"Ciconiidae (Storks)","sp_count":19,"fam":"Ciconiidae"},{"Order":"Coliiformes","Family":"Coliidae (Mousebirds)","sp_count":6,"fam":"Coliidae"},{"Order":"Columbiformes","Family":"Columbidae (Pigeons and Doves)","sp_count":338,"fam":"Columbidae"},{"Order":"Coraciiformes","Family":"Alcedinidae (Kingfishers)","sp_count":117,"fam":"Alcedinidae"},{"Order":"Coraciiformes","Family":"Brachypteraciidae (Ground-Rollers)","sp_count":5,"fam":"Brachypteraciidae"},{"Order":"Coraciiformes","Family":"Coraciidae (Rollers)","sp_count":12,"fam":"Coraciidae"},{"Order":"Coraciiformes","Family":"Meropidae (Bee-eaters)","sp_count":28,"fam":"Meropidae"},{"Order":"Coraciiformes","Family":"Momotidae (Motmots)","sp_count":14,"fam":"Momotidae"},{"Order":"Coraciiformes","Family":"Todidae (Todies)","sp_count":5,"fam":"Todidae"},{"Order":"Cuculiformes","Family":"Cuculidae (Cuckoos)","sp_count":146,"fam":"Cuculidae"},{"Order":"Cuculiformes","Family":"Musophagidae (Turacos)","sp_count":23,"fam":"Musophagidae"},{"Order":"Eurypygiformes","Family":"Eurypygidae (Sunbittern)","sp_count":1,"fam":"Eurypygidae"},{"Order":"Eurypygiformes","Family":"Rhynochetidae (Kagu)","sp_count":1,"fam":"Rhynochetidae"},{"Order":"Falconiformes","Family":"Falconidae (Falcons and Caracaras)","sp_count":65,"fam":"Falconidae"},{"Order":"Galbuliformes","Family":"Bucconidae (Puffbirds)","sp_count":36,"fam":"Bucconidae"},{"Order":"Galbuliformes","Family":"Galbulidae (Jacamars)","sp_count":18,"fam":"Galbulidae"},{"Order":"Galliformes","Family":"Cracidae (Guans, Chachalacas, and Curassows)","sp_count":54,"fam":"Cracidae"},{"Order":"Galliformes","Family":"Megapodiidae (Megapodes)","sp_count":22,"fam":"Megapodiidae"},{"Order":"Galliformes","Family":"Numididae (Guineafowl)","sp_count":6,"fam":"Numididae"},{"Order":"Galliformes","Family":"Odontophoridae (New World Quail)","sp_count":33,"fam":"Odontophoridae"},{"Order":"Galliformes","Family":"Phasianidae (Pheasants, Grouse, and Allies)","sp_count":174,"fam":"Phasianidae"},{"Order":"Gaviiformes","Family":"Gaviidae (Loons)","sp_count":5,"fam":"Gaviidae"},{"Order":"Gruiformes","Family":"Aramidae (Limpkin)","sp_count":1,"fam":"Aramidae"},{"Order":"Gruiformes","Family":"Gruidae (Cranes)","sp_count":15,"fam":"Gruidae"},{"Order":"Gruiformes","Family":"Heliornithidae (Finfoots)","sp_count":3,"fam":"Heliornithidae"},{"Order":"Gruiformes","Family":"Psophiidae (Trumpeters)","sp_count":3,"fam":"Psophiidae"},{"Order":"Gruiformes","Family":"Rallidae (Rails, Gallinules, and Coots)","sp_count":144,"fam":"Rallidae"},{"Order":"Gruiformes","Family":"Sarothruridae (Flufftails)","sp_count":12,"fam":"Sarothruridae"},{"Order":"Leptosomiformes","Family":"Leptosomidae (Cuckoo-Roller)","sp_count":1,"fam":"Leptosomidae"},{"Order":"Mesitornithiformes","Family":"Mesitornithidae (Mesites)","sp_count":3,"fam":"Mesitornithidae"},{"Order":"Opisthocomiformes","Family":"Opisthocomidae (Hoatzin)","sp_count":1,"fam":"Opisthocomidae"},{"Order":"Otidiformes","Family":"Otididae (Bustards)","sp_count":26,"fam":"Otididae"},{"Order":"Passeriformes","Family":"Acanthisittidae (New Zealand Wrens)","sp_count":4,"fam":"Acanthisittidae"},{"Order":"Passeriformes","Family":"Acanthizidae (Thornbills and Allies)","sp_count":64,"fam":"Acanthizidae"},{"Order":"Passeriformes","Family":"Acrocephalidae (Reed-Warblers and Allies)","sp_count":61,"fam":"Acrocephalidae"},{"Order":"Passeriformes","Family":"Aegithalidae (Long-tailed Tits)","sp_count":11,"fam":"Aegithalidae"},{"Order":"Passeriformes","Family":"Aegithinidae (Ioras)","sp_count":4,"fam":"Aegithinidae"},{"Order":"Passeriformes","Family":"Alaudidae (Larks)","sp_count":97,"fam":"Alaudidae"},{"Order":"Passeriformes","Family":"Artamidae (Woodswallows)","sp_count":11,"fam":"Artamidae"},{"Order":"Passeriformes","Family":"Atrichornithidae (Scrub-birds)","sp_count":2,"fam":"Atrichornithidae"},{"Order":"Passeriformes","Family":"Bernieridae (Malagasy Warblers)","sp_count":11,"fam":"Bernieridae"},{"Order":"Passeriformes","Family":"Bombycillidae (Waxwings)","sp_count":3,"fam":"Bombycillidae"},{"Order":"Passeriformes","Family":"Buphagidae (Oxpeckers)","sp_count":2,"fam":"Buphagidae"},{"Order":"Passeriformes","Family":"Calcariidae (Longspurs and Snow Buntings)","sp_count":6,"fam":"Calcariidae"},{"Order":"Passeriformes","Family":"Callaeidae (Wattlebirds)","sp_count":5,"fam":"Callaeidae"},{"Order":"Passeriformes","Family":"Calyptomenidae (African and Green Broadbills)","sp_count":6,"fam":"Calyptomenidae"},{"Order":"Passeriformes","Family":"Campephagidae (Cuckooshrikes)","sp_count":87,"fam":"Campephagidae"},{"Order":"Passeriformes","Family":"Cardinalidae (Cardinals and Allies)","sp_count":48,"fam":"Cardinalidae"},{"Order":"Passeriformes","Family":"Certhiidae (Treecreepers)","sp_count":11,"fam":"Certhiidae"},{"Order":"Passeriformes","Family":"Cettiidae (Bush-Warblers and Allies)","sp_count":36,"fam":"Cettiidae"},{"Order":"Passeriformes","Family":"Chaetopidae (Rockjumpers)","sp_count":2,"fam":"Chaetopidae"},{"Order":"Passeriformes","Family":"Chloropseidae (Leafbirds)","sp_count":11,"fam":"Chloropseidae"},{"Order":"Passeriformes","Family":"Cinclidae (Dippers)","sp_count":5,"fam":"Cinclidae"},{"Order":"Passeriformes","Family":"Cinclosomatidae (Quail-thrushes and Jewel-babblers)","sp_count":11,"fam":"Cinclosomatidae"},{"Order":"Passeriformes","Family":"Cisticolidae (Cisticolas and Allies)","sp_count":147,"fam":"Cisticolidae"},{"Order":"Passeriformes","Family":"Climacteridae (Australasian Treecreepers)","sp_count":7,"fam":"Climacteridae"},{"Order":"Passeriformes","Family":"Cnemophilidae (Satinbirds)","sp_count":3,"fam":"Cnemophilidae"},{"Order":"Passeriformes","Family":"Conopophagidae (Gnateaters)","sp_count":11,"fam":"Conopophagidae"},{"Order":"Passeriformes","Family":"Corcoracidae (White-winged Chough and Apostlebird)","sp_count":2,"fam":"Corcoracidae"},{"Order":"Passeriformes","Family":"Corvidae (Crows, Jays, and Magpies)","sp_count":125,"fam":"Corvidae"},{"Order":"Passeriformes","Family":"Cotingidae (Cotingas)","sp_count":66,"fam":"Cotingidae"},{"Order":"Passeriformes","Family":"Cracticidae (Bellmagpies and Allies)","sp_count":13,"fam":"Cracticidae"},{"Order":"Passeriformes","Family":"Dasyornithidae (Bristlebirds)","sp_count":3,"fam":"Dasyornithidae"},{"Order":"Passeriformes","Family":"Dicaeidae (Flowerpeckers)","sp_count":47,"fam":"Dicaeidae"},{"Order":"Passeriformes","Family":"Dicruridae (Drongos)","sp_count":25,"fam":"Dicruridae"},{"Order":"Passeriformes","Family":"Donacobiidae (Donacobius)","sp_count":1,"fam":"Donacobiidae"},{"Order":"Passeriformes","Family":"Dulidae (Palmchat)","sp_count":1,"fam":"Dulidae"},{"Order":"Passeriformes","Family":"Elachuridae (Spotted Elachura)","sp_count":1,"fam":"Elachuridae"},{"Order":"Passeriformes","Family":"Emberizidae (Buntings and New World Sparrows)","sp_count":172,"fam":"Emberizidae"},{"Order":"Passeriformes","Family":"Estrildidae (Waxbills and Allies)","sp_count":140,"fam":"Estrildidae"},{"Order":"Passeriformes","Family":"Eulacestomatidae (Ploughbill)","sp_count":1,"fam":"Eulacestomatidae"},{"Order":"Passeriformes","Family":"Eupetidae (Rail-babbler)","sp_count":1,"fam":"Eupetidae"},{"Order":"Passeriformes","Family":"Eurylaimidae (Asian and Grauer's Broadbills)","sp_count":9,"fam":"Eurylaimidae"},{"Order":"Passeriformes","Family":"Falcunculidae (Shrike-tit)","sp_count":1,"fam":"Falcunculidae"},{"Order":"Passeriformes","Family":"Formicariidae (Antthrushes)","sp_count":11,"fam":"Formicariidae"},{"Order":"Passeriformes","Family":"Fringillidae (Finches, Euphonias, and Allies)","sp_count":224,"fam":"Fringillidae"},{"Order":"Passeriformes","Family":"Furnariidae (Ovenbirds and Woodcreepers)","sp_count":303,"fam":"Furnariidae"},{"Order":"Passeriformes","Family":"Grallariidae (Antpittas)","sp_count":53,"fam":"Grallariidae"},{"Order":"Passeriformes","Family":"Hirundinidae (Swallows)","sp_count":86,"fam":"Hirundinidae"},{"Order":"Passeriformes","Family":"Hyliotidae (Hyliotas)","sp_count":4,"fam":"Hyliotidae"},{"Order":"Passeriformes","Family":"Hylocitreidae (Hylocitrea)","sp_count":1,"fam":"Hylocitreidae"},{"Order":"Passeriformes","Family":"Hypocoliidae (Hypocolius)","sp_count":1,"fam":"Hypocoliidae"},{"Order":"Passeriformes","Family":"Icteridae (Troupials and Allies)","sp_count":105,"fam":"Icteridae"},{"Order":"Passeriformes","Family":"Ifritidae (Ifrita)","sp_count":1,"fam":"Ifritidae"},{"Order":"Passeriformes","Family":"Irenidae (Fairy-bluebirds)","sp_count":2,"fam":"Irenidae"},{"Order":"Passeriformes","Family":"Laniidae (Shrikes)","sp_count":32,"fam":"Laniidae"},{"Order":"Passeriformes","Family":"Leiothrichidae (Laughingthrushes and Allies)","sp_count":144,"fam":"Leiothrichidae"},{"Order":"Passeriformes","Family":"Locustellidae (Grassbirds and Allies)","sp_count":61,"fam":"Locustellidae"},{"Order":"Passeriformes","Family":"Machaerirhynchidae (Boatbills)","sp_count":2,"fam":"Machaerirhynchidae"},{"Order":"Passeriformes","Family":"Macrosphenidae (African Warblers)","sp_count":21,"fam":"Macrosphenidae"},{"Order":"Passeriformes","Family":"Malaconotidae (Bushshrikes and Allies)","sp_count":49,"fam":"Malaconotidae"},{"Order":"Passeriformes","Family":"Maluridae (Fairywrens)","sp_count":32,"fam":"Maluridae"},{"Order":"Passeriformes","Family":"Melampittidae (Melampittas)","sp_count":2,"fam":"Melampittidae"},{"Order":"Passeriformes","Family":"Melanocharitidae (Berrypeckers and Longbills)","sp_count":10,"fam":"Melanocharitidae"},{"Order":"Passeriformes","Family":"Melanopareiidae (Crescentchests)","sp_count":4,"fam":"Melanopareiidae"},{"Order":"Passeriformes","Family":"Meliphagidae (Honeyeaters)","sp_count":184,"fam":"Meliphagidae"},{"Order":"Passeriformes","Family":"Menuridae (Lyrebirds)","sp_count":2,"fam":"Menuridae"},{"Order":"Passeriformes","Family":"Mimidae (Mockingbirds and Thrashers)","sp_count":34,"fam":"Mimidae"},{"Order":"Passeriformes","Family":"Mohoidae (Hawaiian Honeyeaters)","sp_count":5,"fam":"Mohoidae"},{"Order":"Passeriformes","Family":"Mohouidae (Whiteheads)","sp_count":3,"fam":"Mohouidae"},{"Order":"Passeriformes","Family":"Monarchidae (Monarch Flycatchers)","sp_count":100,"fam":"Monarchidae"},{"Order":"Passeriformes","Family":"Motacillidae (Wagtails and Pipits)","sp_count":66,"fam":"Motacillidae"},{"Order":"Passeriformes","Family":"Muscicapidae (Old World Flycatchers)","sp_count":315,"fam":"Muscicapidae"},{"Order":"Passeriformes","Family":"Nectariniidae (Sunbirds and Spiderhunters)","sp_count":140,"fam":"Nectariniidae"},{"Order":"Passeriformes","Family":"Neosittidae (Sittellas)","sp_count":2,"fam":"Neosittidae"},{"Order":"Passeriformes","Family":"Nicatoridae (Nicators)","sp_count":3,"fam":"Nicatoridae"},{"Order":"Passeriformes","Family":"Notiomystidae (Stitchbird)","sp_count":1,"fam":"Notiomystidae"},{"Order":"Passeriformes","Family":"Oreoicidae (Australo-Papuan Bellbirds)","sp_count":3,"fam":"Oreoicidae"},{"Order":"Passeriformes","Family":"Oriolidae (Old World Orioles)","sp_count":35,"fam":"Oriolidae"},{"Order":"Passeriformes","Family":"Orthonychidae (Logrunners)","sp_count":3,"fam":"Orthonychidae"},{"Order":"Passeriformes","Family":"Oxyruncidae (Sharpbill)","sp_count":1,"fam":"Oxyruncidae"},{"Order":"Passeriformes","Family":"Pachycephalidae (Whistlers and Allies)","sp_count":56,"fam":"Pachycephalidae"},{"Order":"Passeriformes","Family":"Panuridae (Bearded Reedling)","sp_count":1,"fam":"Panuridae"},{"Order":"Passeriformes","Family":"Paradisaeidae (Birds-of-Paradise)","sp_count":39,"fam":"Paradisaeidae"},{"Order":"Passeriformes","Family":"Paradoxornithidae (Parrotbills, Wrentit, and Allies)","sp_count":36,"fam":"Paradoxornithidae"},{"Order":"Passeriformes","Family":"Paramythiidae (Tit Berrypecker and Crested Berrypecker)","sp_count":2,"fam":"Paramythiidae"},{"Order":"Passeriformes","Family":"Pardalotidae (Pardalotes)","sp_count":4,"fam":"Pardalotidae"},{"Order":"Passeriformes","Family":"Paridae (Tits, Chickadees, and Titmice)","sp_count":63,"fam":"Paridae"},{"Order":"Passeriformes","Family":"Parulidae (New World Warblers)","sp_count":116,"fam":"Parulidae"},{"Order":"Passeriformes","Family":"Passeridae (Old World Sparrows)","sp_count":42,"fam":"Passeridae"},{"Order":"Passeriformes","Family":"Pellorneidae (Ground Babblers and Allies)","sp_count":56,"fam":"Pellorneidae"},{"Order":"Passeriformes","Family":"Petroicidae (Australasian Robins)","sp_count":47,"fam":"Petroicidae"},{"Order":"Passeriformes","Family":"Peucedramidae (Olive Warbler)","sp_count":1,"fam":"Peucedramidae"},{"Order":"Passeriformes","Family":"Philepittidae (Asities)","sp_count":4,"fam":"Philepittidae"},{"Order":"Passeriformes","Family":"Phylloscopidae (Leaf Warblers)","sp_count":76,"fam":"Phylloscopidae"},{"Order":"Passeriformes","Family":"Picathartidae (Rockfowl)","sp_count":2,"fam":"Picathartidae"},{"Order":"Passeriformes","Family":"Pipridae (Manakins)","sp_count":54,"fam":"Pipridae"},{"Order":"Passeriformes","Family":"Pittidae (Pittas)","sp_count":44,"fam":"Pittidae"},{"Order":"Passeriformes","Family":"Pityriaseidae (Bristlehead)","sp_count":1,"fam":"Pityriaseidae"},{"Order":"Passeriformes","Family":"Platysteiridae (Wattle-eyes and Batises)","sp_count":30,"fam":"Platysteiridae"},{"Order":"Passeriformes","Family":"Ploceidae (Weavers and Allies)","sp_count":116,"fam":"Ploceidae"},{"Order":"Passeriformes","Family":"Pnoepygidae (Cupwings)","sp_count":5,"fam":"Pnoepygidae"},{"Order":"Passeriformes","Family":"Polioptilidae (Gnatcatchers)","sp_count":15,"fam":"Polioptilidae"},{"Order":"Passeriformes","Family":"Pomatostomidae (Pseudo-Babblers)","sp_count":5,"fam":"Pomatostomidae"},{"Order":"Passeriformes","Family":"Promeropidae (Sugarbirds)","sp_count":5,"fam":"Promeropidae"},{"Order":"Passeriformes","Family":"Prunellidae (Accentors)","sp_count":13,"fam":"Prunellidae"},{"Order":"Passeriformes","Family":"Psophodidae (Whipbirds and Wedgebills)","sp_count":5,"fam":"Psophodidae"},{"Order":"Passeriformes","Family":"Ptiliogonatidae (Silky-flycatchers)","sp_count":4,"fam":"Ptiliogonatidae"},{"Order":"Passeriformes","Family":"Ptilonorhynchidae (Bowerbirds)","sp_count":26,"fam":"Ptilonorhynchidae"},{"Order":"Passeriformes","Family":"Pycnonotidae (Bulbuls)","sp_count":141,"fam":"Pycnonotidae"},{"Order":"Passeriformes","Family":"Regulidae (Kinglets)","sp_count":6,"fam":"Regulidae"},{"Order":"Passeriformes","Family":"Remizidae (Penduline-Tits)","sp_count":11,"fam":"Remizidae"},{"Order":"Passeriformes","Family":"Rhagologidae (Mottled Berryhunter)","sp_count":1,"fam":"Rhagologidae"},{"Order":"Passeriformes","Family":"Rhinocryptidae (Tapaculos)","sp_count":59,"fam":"Rhinocryptidae"},{"Order":"Passeriformes","Family":"Rhipiduridae (Fantails)","sp_count":50,"fam":"Rhipiduridae"},{"Order":"Passeriformes","Family":"Sapayoidae (Sapayoa)","sp_count":1,"fam":"Sapayoidae"},{"Order":"Passeriformes","Family":"Sittidae (Nuthatches)","sp_count":27,"fam":"Sittidae"},{"Order":"Passeriformes","Family":"Stenostiridae (Fairy Flycatchers)","sp_count":9,"fam":"Stenostiridae"},{"Order":"Passeriformes","Family":"Sturnidae (Starlings)","sp_count":122,"fam":"Sturnidae"},{"Order":"Passeriformes","Family":"Sylviidae (Sylviid Warblers)","sp_count":33,"fam":"Sylviidae"},{"Order":"Passeriformes","Family":"Thamnophilidae (Typical Antbirds)","sp_count":234,"fam":"Thamnophilidae"},{"Order":"Passeriformes","Family":"Thraupidae (Tanagers and Allies)","sp_count":386,"fam":"Thraupidae"},{"Order":"Passeriformes","Family":"Tichodromidae (Wallcreeper)","sp_count":1,"fam":"Tichodromidae"},{"Order":"Passeriformes","Family":"Timaliidae (Tree-Babblers, Scimitar-Babblers, and Allies)","sp_count":52,"fam":"Timaliidae"},{"Order":"Passeriformes","Family":"Tityridae (Tityras and Allies)","sp_count":33,"fam":"Tityridae"},{"Order":"Passeriformes","Family":"Troglodytidae (Wrens)","sp_count":85,"fam":"Troglodytidae"},{"Order":"Passeriformes","Family":"Turdidae (Thrushes and Allies)","sp_count":168,"fam":"Turdidae"},{"Order":"Passeriformes","Family":"Tyrannidae (Tyrant Flycatchers)","sp_count":419,"fam":"Tyrannidae"},{"Order":"Passeriformes","Family":"Urocynchramidae (Przevalski's Pinktail)","sp_count":1,"fam":"Urocynchramidae"},{"Order":"Passeriformes","Family":"Vangidae (Vangas, Helmetshrikes, and Allies)","sp_count":39,"fam":"Vangidae"},{"Order":"Passeriformes","Family":"Viduidae (Indigobirds)","sp_count":20,"fam":"Viduidae"},{"Order":"Passeriformes","Family":"Vireonidae (Vireos, Shrike-Babblers, and Erpornis)","sp_count":62,"fam":"Vireonidae"},{"Order":"Passeriformes","Family":"Zosteropidae (White-eyes, Yuhinas, and Allies)","sp_count":129,"fam":"Zosteropidae"},{"Order":"Pelecaniformes","Family":"Ardeidae (Herons, Egrets, and Bitterns)","sp_count":64,"fam":"Ardeidae"},{"Order":"Pelecaniformes","Family":"Balaenicipitidae (Shoebill)","sp_count":1,"fam":"Balaenicipitidae"},{"Order":"Pelecaniformes","Family":"Pelecanidae (Pelicans)","sp_count":8,"fam":"Pelecanidae"},{"Order":"Pelecaniformes","Family":"Scopidae (Hamerkop)","sp_count":1,"fam":"Scopidae"},{"Order":"Pelecaniformes","Family":"Threskiornithidae (Ibises and Spoonbills)","sp_count":34,"fam":"Threskiornithidae"},{"Order":"Phaethontiformes","Family":"Phaethontidae (Tropicbirds)","sp_count":3,"fam":"Phaethontidae"},{"Order":"Phoenicopteriformes","Family":"Phoenicopteridae (Flamingos)","sp_count":6,"fam":"Phoenicopteridae"},{"Order":"Piciformes","Family":"Capitonidae (New World Barbets)","sp_count":14,"fam":"Capitonidae"},{"Order":"Piciformes","Family":"Indicatoridae (Honeyguides)","sp_count":17,"fam":"Indicatoridae"},{"Order":"Piciformes","Family":"Lybiidae (African Barbets)","sp_count":42,"fam":"Lybiidae"},{"Order":"Piciformes","Family":"Megalaimidae (Asian Barbets)","sp_count":34,"fam":"Megalaimidae"},{"Order":"Piciformes","Family":"Picidae (Woodpeckers)","sp_count":230,"fam":"Picidae"},{"Order":"Piciformes","Family":"Ramphastidae (Toucans)","sp_count":35,"fam":"Ramphastidae"},{"Order":"Piciformes","Family":"Semnornithidae (Toucan-Barbets)","sp_count":2,"fam":"Semnornithidae"},{"Order":"Podicipediformes","Family":"Podicipedidae (Grebes)","sp_count":22,"fam":"Podicipedidae"},{"Order":"Procellariiformes","Family":"Diomedeidae (Albatrosses)","sp_count":15,"fam":"Diomedeidae"},{"Order":"Procellariiformes","Family":"Hydrobatidae (Storm-Petrels)","sp_count":27,"fam":"Hydrobatidae"},{"Order":"Procellariiformes","Family":"Procellariidae (Shearwaters and Petrels)","sp_count":92,"fam":"Procellariidae"},{"Order":"Psittaciformes","Family":"Cacatuidae (Cockatoos)","sp_count":21,"fam":"Cacatuidae"},{"Order":"Psittaciformes","Family":"Psittacidae (New World and African Parrots)","sp_count":168,"fam":"Psittacidae"},{"Order":"Psittaciformes","Family":"Psittaculidae (Old World Parrots)","sp_count":179,"fam":"Psittaculidae"},{"Order":"Psittaciformes","Family":"Strigopidae (New Zealand Parrots)","sp_count":4,"fam":"Strigopidae"},{"Order":"Pterocliformes","Family":"Pteroclidae (Sandgrouse)","sp_count":16,"fam":"Pteroclidae"},{"Order":"Rheiformes","Family":"Rheidae (Rheas)","sp_count":2,"fam":"Rheidae"},{"Order":"Sphenisciformes","Family":"Spheniscidae (Penguins)","sp_count":18,"fam":"Spheniscidae"},{"Order":"Strigiformes","Family":"Strigidae (Owls)","sp_count":207,"fam":"Strigidae"},{"Order":"Strigiformes","Family":"Tytonidae (Barn-Owls)","sp_count":18,"fam":"Tytonidae"},{"Order":"Struthioniformes","Family":"Struthionidae (Ostriches)","sp_count":2,"fam":"Struthionidae"},{"Order":"Suliformes","Family":"Anhingidae (Anhingas)","sp_count":4,"fam":"Anhingidae"},{"Order":"Suliformes","Family":"Fregatidae (Frigatebirds)","sp_count":5,"fam":"Fregatidae"},{"Order":"Suliformes","Family":"Phalacrocoracidae (Cormorants and Shags)","sp_count":40,"fam":"Phalacrocoracidae"},{"Order":"Suliformes","Family":"Sulidae (Boobies and Gannets)","sp_count":10,"fam":"Sulidae"},{"Order":"Tinamiformes","Family":"Tinamidae (Tinamous)","sp_count":47,"fam":"Tinamidae"},{"Order":"Trogoniformes","Family":"Trogonidae (Trogons)","sp_count":44,"fam":"Trogonidae"}]

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

module.exports = {"vege":"(((((((Cassava:8.355911,Chaya:8.355911):107.430373,((((((((Cucumber:9.286953,West_Indian_gherkin:9.286952):3.990006,Ivy_gourd:13.27696):0.34841,Winter_melon:13.625369):6.512963,Zucchini_/_Courgette_/_Marrow:20.138332):3.3158,Chayote:23.454132):1.312942,Fluted_pumpkin:24.767074):2.031642,Bitter_melon_Bitter_gourd:26.798717)Cucurbitaceae:85.902882,(((((Fava_bean:11.360279,((Earthnut_pea:7.49896,Indian_pea:7.498961):2.558218,Pea:10.057179):1.3031):0.198223,Lentil:11.558501):14.204207,Chickpea:25.762709):31.868753,((((((Soybean:17.833331,(Jícama:4.331277,Ahipa:4.331297):13.502055):12.613718,(((((Lima_bean:9.73921,((Runner_bean:3.789957,Common_bean:3.789958):3.640124,Tepary_bean:7.430083):2.309127):3.996246,(((Urad_bean:1.7298,Mung_bean:1.7298):2.126368,Azuki_bean:3.856169):3.669939,Black-eyed_pea:7.526107):6.209349):1.309291,Dolichos_bean:15.044748):3.519088,Horse_gram:18.563834):11.580119,Winged_bean:30.143954):0.303097):1.202173,Pigeon_pea:31.649224):1.453491,Velvet_bean:33.102716):0.88394,American_groundnut:33.986656):16.530887,Guar:50.517542):7.113922):6.584434,Tarwi:64.215896)Fabaceae:48.48543):3.084369):2.793039,(((Melokhia:38.361113,(Okra:19.553061,Chinese_mallow:19.553062):18.808055):54.592383,((((((((Bok_choy:3.627252,Yao_choy:3.627253):1.30287,Broccoli:4.930123):16.919844,Daikon:21.849967):1.239293,(Mustard:21.398069,Sea_kale:21.39809):1.69119):4.359884,((Shepherd's_purse:23.015619,(Watercress:16.785169,(Land_cress:15.140502,Horseradish:15.140501):1.644667):6.23045):0.423589,Cress:23.439208):4.009936)Brassicaceae:16.774279,Caper:44.223422):34.765753,Drumstick:78.989175):2.611864,Mashua:81.601039):11.352656):23.424956,Water_caltrop:116.378826):2.200511):5.155633,((((((Chinese_artichoke:52.932747,Greater_plantain:52.93274):18.087847,Olive_fruit:71.020587):17.227558,Borage_greens:88.248237):1.503291,(((Eggplant:12.514115,(Tomato:5.785041,Potato:5.785041):6.729076):5.88232,(Tomatillo:17.566558,Bell_pepper:17.566559):0.829877):48.253368,(Water_spinach:8.214471,Sweet_potato:8.21447):58.435334):23.101343):16.990343,(((((Yacón:17.695325,Jerusalem_artichoke:17.695323):5.294113,Yarrow:22.98944):7.684679,((((Dandelion:10.595603,Catsear:10.595603):2.300967,Lettuce:12.896569):3.677891,(Endive:0.081807,Chicory:0.081806):16.492656):9.204894,(Salsify:11.329901,Scorzonera:11.329901):14.449454):4.894761):3.606085,(Burdock:9.425077,Cardoon:9.425077):24.855125)Asteraceae:59.450588,(Corn_salad:85.640992,((((Arracacha:9.372841,Parsnip:9.37284):7.129462,(Samphire:16.29616,(((Hamburg_parsley:8.902762,Florence_fennel:8.902761):0.150892,Celery:9.053653):1.617349,Dill:10.6706973):5.625158):0.206142):6.030024,(Carrot:16.938348,Pignut:16.93835):5.593976):1.071837,Skirret:23.604162)Apiaceae:62.036734):8.089557):13.011199):13.132823,((((Poke:74.87614,New_Zealand_Spinach:74.87614):8.079282,(Miner's_lettuce:42.804503,((Ulluco:18.485646,Malabar_spinach:18.485646):21.02972,(Lagos_bologi:33.316664,(Common_purslane:28.803149,Nopal:28.803152):4.513514):6.198702):3.289137):40.150918):4.895165,(Soko:43.661307,((Spinach:22.016367,(Fat_hen:8.180573,Orache:8.180574):13.835793):12.899725,Beet:34.916091):8.745214):44.189279):19.200704,Sorrel:107.0510207):12.823236):3.860003):6.590294,Lotus_root:130.324697):5.433534,(((((Galangal:19.909897,(Turmeric:12.266137,Ginger:12.266138):7.643759):38.350654,Ensete:58.260552):48.473737,((Lemongrass:39.751061,((Wheatgrass:33.90357,Bamboo_shoot:33.903572):1.751188,Gau_soon:35.654758):4.096302):54.070428,(Tigernut:23.259159,Water_chestnut:23.259159):70.562329):12.912178):7.866937,(Daylily:67.550469,(((Welsh_onion:12.534394,Garlic_chives:12.534395):0.413866,Wild_leek:12.948259):49.545101,(Ti:41.999756,Asparagus:41.999756):20.493605):5.057108):47.050858):16.198196,(Broadleaf_arrowhead:128.861356,(Elephant_foot_yam:109.115985,Taro:109.115984):19.745371):1.937921)Monocots:4.959306):0.154122,(Avocado:132.393873,Lizard's_tail:132.39438):3.518306)Angiosperms;","life":"(((((((((((((((((((Escherichia_coli_EDL933:0.00000,Escherichia_coli_O157_H7:0.00000)Escherichia_subclade:0.00044[96],((Escherichia_coli_O6:0.00000,Escherichia_coli_K12:0.00022)Escherichia_subclade:0.00022[76],(Shigella_flexneri_2a_2457T:0.00000,Shigella_flexneri_2a_301:0.00000)Shigella:0.00266[100])Enterobacteriaceae_subclade:0.00000[75])Enterobacteriaceae_subclade:0.00813[100],((Salmonella_enterica:0.00000,Salmonella_typhi:0.00000)Salmonella_subclade:0.00146[100],Salmonella_typhimurium:0.00075)Salmonella:0.00702[100])Enterobacteriaceae_subclade:0.03131[100],((Yersinia_pestis_Medievalis:0.00000,(Yersinia_pestis_KIM:0.00000,Yersinia_pestis_CO92:0.00000)Yersinia_subclade:0.00000[31])Yersinia:0.03398[100],Photorhabdus_luminescens:0.05076)Enterobacteriaceae_subclade:0.01182[61])Enterobacteriaceae_subclade:0.02183[98],((Blochmannia_floridanus:0.32481,Wigglesworthia_brevipalpis:0.35452)Enterobacteriaceae_subclade:0.08332[100],(Buchnera_aphidicola_Bp:0.27492,(Buchnera_aphidicola_APS:0.09535,Buchnera_aphidicola_Sg:0.10235)Buchnera_subclade:0.10140[100])Buchnera:0.06497[100])Enterobacteriaceae_subclade:0.15030[100])Enterobacteriaceae:0.02808[100],((Pasteurella_multocida:0.03441,Haemophilus_influenzae:0.03754)Pasteurellaceae_subclade:0.01571[94],Haemophilus_ducreyi:0.05333)Pasteurellaceae:0.07365[100])Gammaproteobacteria_subclade:0.03759[100],((((Vibrio_vulnificus_YJ016:0.00021,Vibrio_vulnificus_CMCP6:0.00291)Vibrio_subclade:0.01212[100],Vibrio_parahaemolyticus:0.01985)Vibrio_subclade:0.01536[100],Vibrio_cholerae:0.02995)Vibrio:0.02661[100],Photobacterium_profundum:0.06131)Vibrionaceae:0.05597[100])Gammaproteobacteria_subclade:0.03492[81],Shewanella_oneidensis:0.10577)Gammaproteobacteria_subclade:0.12234[100],((Pseudomonas_putida:0.02741,Pseudomonas_syringae:0.03162)Pseudomonas_subclade:0.02904[100],Pseudomonas_aeruginosa:0.03202)Pseudomonas:0.14456[100])Gammaproteobacteria_subclade:0.04492[98],((Xylella_fastidiosa_700964:0.01324,Xylella_fastidiosa_9a5c:0.00802)Xylella:0.10192[100],(Xanthomonas_axonopodis:0.01069,Xanthomonas_campestris:0.00934)Xanthomonas:0.05037[100])Xanthomonadaceae:0.24151[100])Gammaproteobacteria_subclade:0.02475[49],Coxiella_burnetii:0.33185)Gammaproteobacteria:0.03328[54],((((Neisseria_meningitidis_A:0.00400,Neisseria_meningitidis_B:0.00134)Neisseria:0.12615[100],Chromobacterium_violaceum:0.09623)Neisseriaceae:0.07131[100],((Bordetella_pertussis:0.00127,(Bordetella_parapertussis:0.00199,Bordetella_bronchiseptica:0.00022)Bordetella_subclade:0.00006[67])Bordetella:0.14218[100],Ralstonia_solanacearum:0.11464)Burkholderiales:0.08478[100])Betaproteobacteria_subclade:0.03840[75],Nitrosomonas_europaea:0.22059)Betaproteobacteria:0.08761[100])Proteobacteria_subclade:0.16913[100],((((((Agrobacterium_tumefaciens_Cereon:0.00000,Agrobacterium_tumefaciens_WashU:0.00000):0.05735[100],Rhizobium_meliloti:0.05114)Sinorhizobium:0.05575[100],((Brucella_suis:0.00102,Brucella_melitensis:0.00184)Brucella:0.08660[100],Rhizobium_loti:0.09308)Rhizobiales_subclade:0.02384[51])Rhizobiales_subclade:0.08637[100],(Rhodopseudomonas_palustris:0.04182,Bradyrhizobium_japonicum:0.06346)Bradyrhizobiaceae:0.14122[100])Rhizobiales:0.05767[100],Caulobacter_crescentus:0.23943)Alphaproteobacteria_subclade:0.11257[100],(Wolbachia_sp._wMel:0.51596,(Rickettsia_prowazekii:0.04245,Rickettsia_conorii:0.02487)Rickettsia:0.38019[100])Rickettsiaceae:0.12058[100])Alphaproteobacteria:0.12365[100])Proteobacteria_subclade:0.06301[100],((((Helicobacter_pylori_J99:0.00897,Helicobacter_pylori_26695:0.00637)Helicobacter_subclade:0.19055[100],Helicobacter_hepaticus:0.12643)Helicobacter:0.05330[100],Wolinella_succinogenes:0.11644)Helicobacteraceae:0.09105[100],Campylobacter_jejuni:0.20399)Campylobacterales:0.41390[100])Proteobacteria_subclade:0.04428[82],((Desulfovibrio_vulgaris:0.38320,(Geobacter_sulfurreducens:0.22491,Bdellovibrio_bacteriovorus:0.45934)Deltaproteobacteria_subclade:0.04870[43])Deltaproteobacteria:0.04100[69],(Acidobacterium_capsulatum:0.24572,Solibacter_usitatus:0.29086)Acidobacteria:0.20514[100])Bacteria_subclade:0.04214[64])Bacteria_subclade:0.05551[98],((Fusobacterium_nucleatum:0.45615,(Aquifex_aeolicus:0.40986,Thermotoga_maritima:0.34182)Bacteria_subclade:0.07696[100])Bacteria_subclade:0.03606[35],(((Thermus_thermophilus:0.26583,Deinococcus_radiodurans:0.29763)Deinococci:0.24776[100],Dehalococcoides_ethenogenes:0.53988)Bacteria_subclade:0.04370[35],((((Nostoc_sp._PCC_7120:0.12014,Synechocystis_sp._PCC6803:0.15652)Cyanobacteria_subclade:0.04331[98],Synechococcus_elongatus:0.13147)Cyanobacteria_subclade:0.05040[100],(((Synechococcus_sp._WH8102:0.06780,Prochlorococcus_marinus_MIT9313:0.05434)Cyanobacteria_subclade:0.04879[100],Prochlorococcus_marinus_SS120:0.10211)Cyanobacteria_subclade:0.04238[74],Prochlorococcus_marinus_CCMP1378:0.16170)Cyanobacteria_subclade:0.20442[100])Cyanobacteria_subclade:0.07646[100],Gloeobacter_violaceus:0.23764)Cyanobacteria:0.24501[100])Bacteria_subclade:0.04332[39])Bacteria_subclade:0.02720[51])Bacteria_subclade:0.03471[74],((((Gemmata_obscuriglobus:0.36751,Rhodopirellula_baltica:0.38017)Planctomycetaceae:0.24062[100],((Leptospira_interrogans_L1-130:0.00000,Leptospira_interrogans_56601:0.00027)Leptospira:0.47573[100],((Treponema_pallidum:0.25544,Treponema_denticola:0.16072)Treponema:0.19057[100],Borrelia_burgdorferi:0.42323)Spirochaetaceae:0.20278[100])Spirochaetales:0.07248[95])Bacteria_subclade:0.04615[42],(((Tropheryma_whipplei_TW08/27:0.00009,Tropheryma_whipplei_Twist:0.00081)Tropheryma:0.44723[100],Bifidobacterium_longum:0.29283)Actinobacteridae_subclade:0.14429[100],(((((Corynebacterium_glutamicum_13032:0.00022,Corynebacterium_glutamicum:0.00000)Corynebacterium_subclade:0.03415[100],Corynebacterium_efficiens:0.02559)Corynebacterium_subclade:0.03682[100],Corynebacterium_diphtheriae:0.06479)Corynebacterium:0.13907[100],(((Mycobacterium_bovis:0.00067,(Mycobacterium_tuberculosis_CDC1551:0.00000,Mycobacterium_tuberculosis_H37Rv:0.00000)Mycobacterium_subclade:0.00022[98])Mycobacterium_subclade:0.03027[100],Mycobacterium_leprae:0.05135)Mycobacterium_subclade:0.01514[97],Mycobacterium_paratuberculosis:0.02091)Mycobacterium:0.11523[100])Corynebacterineae:0.09883[100],(Streptomyces_avermitilis:0.02680,Streptomyces_coelicolor:0.02678)Streptomyces:0.16707[100])Actinomycetales_subclade:0.06110[91])Actinobacteridae:0.26800[100])Bacteria_subclade:0.03480[23],((Fibrobacter_succinogenes:0.51984,(Chlorobium_tepidum:0.37204,(Porphyromonas_gingivalis:0.11304,Bacteroides_thetaiotaomicron:0.13145)Bacteroidales:0.34694[100])Bacteroidetes/Chlorobi_group:0.09237[100])Bacteria_subclade:0.04841[62],(((Chlamydophila_pneumoniae_TW183:0.00000,(Chlamydia_pneumoniae_J138:0.00000,(Chlamydia_pneumoniae_CWL029:0.00000,Chlamydia_pneumoniae_AR39:0.00000)Chlamydophila_subclade:0.00000[37])Chlamydophila_subclade:0.00000[44])Chlamydophila_subclade:0.10482[100],Chlamydophila_caviae:0.05903)Chlamydophila:0.04170[98],(Chlamydia_muridarum:0.01938,Chlamydia_trachomatis:0.02643)Chlamydia:0.06809[100])Chlamydiaceae:0.60169[100])Bacteria_subclade:0.04443[32])Bacteria_subclade:0.04284[67])Bacteria_subclade:0.02646[66],((Thermoanaerobacter_tengcongensis:0.17512,((Clostridium_tetani:0.10918,Clostridium_perfringens:0.11535)Clostridium_subclade:0.03238[78],Clostridium_acetobutylicum:0.11396)Clostridium:0.15056[100])Clostridia:0.11788[100],(((((Mycoplasma_mobile:0.27702,Mycoplasma_pulmonis:0.28761)Mycoplasma_subclade:0.28466[100],((((Mycoplasma_pneumoniae:0.10966,Mycoplasma_genitalium:0.11268)Mycoplasma_subclade:0.31768[100],Mycoplasma_gallisepticum:0.24373)Mycoplasma_subclade:0.14180[100],Mycoplasma_penetrans:0.34890)Mycoplasma_subclade:0.06674[94],Ureaplasma_parvum:0.33874)Mycoplasmataceae_subclade:0.19177[100])Mycoplasmataceae_subclade:0.07341[100],Mycoplasma_mycoides:0.37680)Mycoplasmataceae:0.12541[100],Phytoplasma_Onion_yellows:0.47843)Mollicutes:0.09099[100],(((((Listeria_monocytogenes_F2365:0.00063,Listeria_monocytogenes_EGD:0.00144)Listeria_subclade:0.00235[90],Listeria_innocua:0.00248)Listeria:0.13517[100],((Oceanobacillus_iheyensis:0.13838,Bacillus_halodurans:0.09280)Bacillaceae_subclade:0.02676[91],(((Bacillus_cereus_ATCC_14579:0.00342,Bacillus_cereus_ATCC_10987:0.00123)Bacillus_subclade:0.00573[100],Bacillus_anthracis:0.00331)Bacillus_subclade:0.08924[100],Bacillus_subtilis:0.07876)Bacillus:0.01984[96])Bacillaceae:0.03907[100])Bacillales_subclade:0.02816[69],((Staphylococcus_aureus_MW2:0.00000,(Staphylococcus_aureus_N315:0.00022,Staphylococcus_aureus_Mu50:0.00022)Staphylococcus_subclade:0.00022[61])Staphylococcus_subclade:0.02479[100],Staphylococcus_epidermidis:0.03246)Staphylococcus:0.17366[100])Bacillales:0.02828[64],(((((((Streptococcus_agalactiae_III:0.00110,Streptococcus_agalactiae_V:0.00155)Streptococcus_subclade:0.01637[100],(Streptococcus_pyogenes_M1:0.00134,(Streptococcus_pyogenes_MGAS8232:0.00045,(Streptococcus_pyogenes_MGAS315:0.00000,Streptococcus_pyogenes_SSI-1:0.00022)Streptococcus_subclade:0.00110[100])Streptococcus_subclade:0.00066[87])Streptococcus_subclade:0.02250[100])Streptococcus_subclade:0.01360[100],Streptococcus_mutans:0.04319)Streptococcus_subclade:0.01920[99],(Streptococcus_pneumoniae_R6:0.00119,Streptococcus_pneumoniae_TIGR4:0.00124)Streptococcus_subclade:0.03607[100])Streptococcus:0.04983[100],Lactococcus_lactis:0.11214)Streptococcaceae:0.08901[100],Enterococcus_faecalis:0.07946)Lactobacillales_subclade:0.03958[100],(Lactobacillus_johnsonii:0.20999,Lactobacillus_plantarum:0.14371)Lactobacillus:0.06763[100])Lactobacillales:0.08989[100])Bacilli:0.08905[100])Firmicutes_subclade:0.09540[92])Firmicutes:0.04315[54])Bacteria:1.34959,(((((Thalassiosira_pseudonana:0.33483,(Cryptosporidium_hominis:0.25048,Plasmodium_falciparum:0.28267)Apicomplexa:0.14359[100])Eukaryota_subclade:0.03495[42],(((Oryza_sativa:0.07623,Arabidopsis_thaliana:0.09366)Streptophyta:0.15770[100],Cyanidioschyzon_merolae:0.38319)Eukaryota_subclade:0.08133[96],(Dictyostelium_discoideum:0.34685,(((Eremothecium_gossypii:0.07298,Saccharomyces_cerevisiae:0.07619)Saccharomycetaceae:0.21170[100],Schizosaccharomyces_pombe:0.24665)Ascomycota:0.15370[100],(((Anopheles_gambiae:0.10724,Drosophila_melanogaster:0.10233)Diptera:0.09870[100],((Takifugu_rubripes:0.03142,Danio_rerio:0.05230)Actinopterygii:0.04335[100],(((Rattus_norvegicus:0.03107,Mus_musculus:0.01651)Murinae:0.00398[91],(Homo_sapiens:0.00957,Pan_troglodytes:0.03864)Hominidae:0.01549[100])Euarchontoglires:0.01629[99],Gallus_gallus:0.04596)Gnathostomata_subclade:0.01859[100])Gnathostomata:0.09688[100])Metazoa_subclade:0.03693[95],(Caenorhabditis_elegans:0.01843,Caenorhabditis_briggsae:0.01896)Caenorhabditis:0.24324[100])Metazoa:0.09911[100])Eukaryota_subclade:0.04004[85])Eukaryota_subclade:0.02708[41])Eukaryota_subclade:0.02636[44])Eukaryota_subclade:0.06455[87],Leishmania_major:0.45664)Eukaryota_subclade:0.10129[100],Giardia_lamblia:0.55482)Eukaryota:0.57543[100],((Nanoarchaeum_equitans:0.81078,(((Sulfolobus_tokodaii:0.17389,Sulfolobus_solfataricus:0.18962)Sulfolobus:0.33720[100],Aeropyrum_pernix:0.43380)Thermoprotei_subclade:0.09462[94],Pyrobaculum_aerophilum:0.55514)Thermoprotei:0.12018[100])Archaea_subclade:0.15444[100],((Thermoplasma_volcanium:0.10412,Thermoplasma_acidophilum:0.09785)Thermoplasma:0.66151[100],((((Methanobacterium_thermautotrophicum:0.36583,Methanopyrus_kandleri:0.35331)Euryarchaeota_subclade:0.07446[99],(Methanococcus_maripaludis:0.28592,Methanococcus_jannaschii:0.13226)Methanococcales:0.23828[100])Euryarchaeota_subclade:0.06284[100],((Pyrococcus_horikoshii:0.02786,Pyrococcus_abyssi:0.02179)Pyrococcus_subclade:0.02239[100],Pyrococcus_furiosus:0.02366)Pyrococcus:0.36220[100])Euryarchaeota_subclade:0.04469[51],(Archaeoglobus_fulgidus:0.34660,(Halobacterium_sp._NRC-1:0.61597,(Methanosarcina_acetivorans:0.02602,Methanosarcina_mazei:0.03087)Methanosarcina:0.30588[100])Euryarchaeota_subclade:0.12801[100])Euryarchaeota_subclade:0.10395[100])Euryarchaeota_subclade:0.06815[62])Euryarchaeota:0.11833[99])Archaea:0.43325[100]):0.88776);","bird":"((Tinamidae_-Tinamous:67.76573872,((Rheidae_-Rheas:43.39492533,(Casuariidae_-Cassowaries_and_Emu:36.44398598,Apterygidae_-Kiwis:36.44398598):6.950939345):6.042291914,Struthionidae_-Ostriches:49.43721724):18.32852148):33.73426738,((((((Odontophoridae_-New_World_Quail:35.9543788,Phasianidae_-Pheasants_Grouse_and_Allies:35.9543788):1.830651218,Numididae_-Guineafowl:37.78503002):18.48261231,Cracidae_-Guans_Chachalacas_and_Curassows:56.26764233):9.186143618,Megapodiidae_-Megapodes:65.45378595):9.271864101,(Anhimidae_-Screamers:69.24958846,(Anseranatidae_-Magpie_Goose:60.65870582,Anatidae_-Ducks_Geese_and_Waterfowl:60.65870582):8.590882649):5.476061582):26.45077673,((((Eurypygidae_-Sunbittern:27.31954432,Rhynochetidae_-Kagu:27.31954432):52.26213926,((((Podargidae_-Frogmouths:72.79118827,(Aegothelidae_-Owlet-nightjars:64.2931289,(Trochilidae_-Hummingbirds:56.76713909,(Apodidae_-Swifts:48.43905475,Hemiprocnidae_-Treeswifts:48.43905475):8.328084346):7.525989814):8.498059365):1.613997335,Caprimulgidae_-Nightjars_and_Allies:74.40518561):0.9137984486,Steatornithidae_-Oilbird:75.31898406):0.3699779789,Nyctibiidae_-Potoos:75.68896204):3.892721543):2.092002108,((((Turnicidae_-Buttonquail:57.59397559,((Laridae_-Gulls_Terns_and_Skimmers:24.03619818,(Alcidae_-Auks_Murres_and_Puffins:21.85422292,Stercorariidae_-Skuas_and_Jaegers:21.85422291):2.181975266):4.56263893,(Glareolidae_-Pratincoles_and_Coursers:26.33809289,Dromadidae_-Crab_Plover:26.33809289):2.260744218):28.99513848):5.701717108,((Rostratulidae_-Painted-Snipes:46.8706095,(Jacanidae_-Jacanas:35.33912267,Scolopacidae_-Sandpipers_and_Allies:35.33912267):11.53148682):5.576384708,(Thinocoridae_-Seedsnipes:42.96646281,Pedionomidae_-Plains-wanderer:42.96646281):9.480531392):10.8486985):6.203846179,((Pluvianidae_-Egyptian_Plover:62.91754188,(Charadriidae_-Plovers_and_Lapwings:45.1089779,(Ibidorhynchidae_-Ibisbill:44.19590316,(Haematopodidae_-Oystercatchers:30.85971177,Recurvirostridae_-Stilts_and_Avocets:30.85971178):13.33619139):0.9130747379):17.80856398):1.961758327,((Pluvianellidae_-Magellanic_Plover:34.42448032,Chionidae_-Sheathbills:34.42448033):25.54279735,Burhinidae_-Thick-knees:59.96727768):4.912022529):4.620238674):11.66736693,((Coliidae_-Mousebirds:79.03005981,(Cariamidae_-Seriemas:77.78606465,(Falconidae_-Falcons_and_Caracaras:77.51521311,((((Psittaculidae_-Old_World_Parrots:32.21397258,Psittacidae_-New_World_and_African_Parrots:32.21397258):14.3231154,Cacatuidae_-Cockatoos:46.53708797):8.475801001,Strigopidae_-New_Zealand_Parrots:55.01288897):20.89517984,(Acanthisittidae_-New_Zealand_Wrens:70.28876136,(((Sapayoidae_-Sapayoa:41.82004133,((Pittidae_-Pittas:37.32982929,Calyptomenidae_-African_and_Green_Broadbills:37.32982929):3.18273313,(Eurylaimidae_-Asian_and_Grauer's_Broadbills:27.04502058,Philepittidae_-Asities:27.04502057):13.46754185):1.307478907):16.14067087,(((((Tyrannidae_-Tyrant_Flycatchers:33.6934837,Pipridae_-Manakins:33.6934837):1.406557111,Tityridae_-Tityras_and_Allies:35.10004081):0.1922664247,Oxyruncidae_-Sharpbill:35.29230724):1.752916132,Cotingidae_-Cotingas:37.04522338):13.1186354,(Thamnophilidae_-Typical_Antbirds:36.74420465,((Conopophagidae_-Gnateaters:35.69875823,Melanopareiidae_-Crescentchests:35.69875822):0.5427859899,((Furnariidae_-Ovenbirds_and_Woodcreepers:27.64522365,Formicariidae_-Antthrushes:27.64522365):3.97413461,(Rhinocryptidae_-Tapaculos:29.30758824,Grallariidae_-Antpittas:29.30758824):2.311770022):4.622185952):0.5026604405):13.41965412):7.796853421):9.618578685,((Menuridae_-Lyrebirds:22.572992,Atrichornithidae_-Scrub-birds:22.572992):38.2312107,((Ptilonorhynchidae_-Bowerbirds:52.71436087,Climacteridae_-Australasian_Treecreepers:52.71436087):4.557018671,((Maluridae_-Fairywrens:43.02532487,(Dasyornithidae_-Bristlebirds:42.22581833,((Pardalotidae_-Pardalotes:35.69227695,(Meliphagidae_-Honeyeaters:16.10131157,Zosteropidae_-White-eyes_Yuhinas_and_Allies:16.10131158):19.59096537):0.7042062022,Acanthizidae_-Thornbills_and_Allies:36.39648315):5.82933518):0.7995065394):12.6651552,((Pomatostomidae_-Pseudo-Babblers:42.88085421,Orthonychidae_-Logrunners:42.88085422):9.850318883,(((Melanocharitidae_-Berrypeckers_and_Longbills:36.17445833,(Callaeidae_-Wattlebirds:35.58999979,(Cnemophilidae_-Satinbirds:33.95394008,Notiomystidae_-Stitchbird:33.95394008):1.636059709):0.5844585464):13.5704868,(((((((Cracticidae_-Bellmagpies_and_Allies:28.68372219,Artamidae_-Woodswallows:28.68372219):3.265736842,Machaerirhynchidae_-Boatbills:31.94945903):1.364568643,((Aegithinidae_-Ioras:26.64864786,(Pityriaseidae_-Bristlehead:24.00274326,Rhagologidae_-Mottled_Berryhunter:24.00274326):2.645904597):6.090843464,(Malaconotidae_-Bushshrikes_and_Allies:31.39246006,(Platysteiridae_-Wattle-eyes_and_Batises:30.76900303,Vangidae_-Vangas_Helmetshrikes_and_Allies:30.76900304):0.6234570178):1.347031269):0.5745363485):0.3264694381,Oreoicidae_-Australo-Papuan_Bellbirds:33.64049711):2.61669629,Campephagidae_-Cuckooshrikes:36.2571934):0.3726121074,((Eulacestomatidae_-Ploughbill:29.29266198,((Mohouidae_-Whiteheads:17.04176022,Psophodidae_-Whipbirds_and_Wedgebills:17.04176022):9.463816799,Cinclosomatidae_-Quail-thrushes_and_Jewel-babblers:26.50557702):2.787084955):3.716707969,Falcunculidae_-Shrike-tit:33.00936995):3.620435565):3.742012673,(((Vireonidae_-Vireos_Shrike-Babblers_and_Erpornis:31.97636299,((Oriolidae_-Old_World_Orioles:21.98840395,Paramythiidae_-Tit_Berrypecker_and_Crested_Berrypecker:21.98840395):6.174126645,(((Corcoracidae_-White-winged_Chough_and_Apostlebird:24.86529218,Rhipiduridae_-Fantails:24.86529217):0.962005197,((Corvidae_-Crows_Jays_and_Magpies:22.87557303,Laniidae_-Shrikes:22.87557303):1.728298436,((Ifritidae_-Ifrita:19.92325798,Melampittidae_-Melampittas:19.92325798):3.423337565,(Monarchidae_-Monarch_Flycatchers:21.49206065,Paradisaeidae_-Birds-of-Paradise:21.49206065):1.854534897):1.257275925):1.223425904):0.4518703677,Dicruridae_-Drongos:26.27916774):1.883362849):3.813832405):5.218166331,Neosittidae_-Sittellas:37.19452933):2.463954012,Pachycephalidae_-Whistlers_and_Allies:39.65848334):0.7133348414):9.373126964):1.246475389,(((Chaetopidae_-Rockjumpers:25.81101332,Eupetidae_-Rail-babbler:25.81101332):4.475267821,Picathartidae_-Rockfowl:30.28628114):17.04699201,(Petroicidae_-Australasian_Robins:46.02308499,((((Stenostiridae_-Fairy_Flycatchers:0.4862639346,Paridae_-Tits_Chickadees_and_Titmice:0.4862639346):37.70999216,Remizidae_-Penduline-Tits:38.1962561):0.2675104843,(((Hirundinidae_-Swallows:28.0808345,((Aegithalidae_-Long-tailed_Tits:23.48848231,((Phylloscopidae_-Leaf_Warblers:19.83629291,Cettiidae_-Bush-Warblers_and_Allies:19.83629291):3.035584338,Macrosphenidae_-African_Warblers:22.87187724):0.6166050672):2.60515656,((((Acrocephalidae_-Reed-Warblers_and_Allies:0.7845084978,Locustellidae_-Grassbirds_and_Allies:0.7845084978):11.71548376,Bernieridae_-Malagasy_Warblers:12.49999226):12.29764135,Donacobiidae_-Donacobius:24.79763361):1.295744325,Hyliotidae_-Hyliotas:26.09337793):0.0002609363887):1.98719563):1.666850219,(Pycnonotidae_-Bulbuls:26.57800649,((Paradoxornithidae_-Parrotbills_Wrentit_and_Allies:18.0520763,(((Timaliidae_-Tree-Babblers_Scimitar-Babblers_and_Allies:6.985074319,Motacillidae_-Wagtails_and_Pipits:6.985074319):9.167285261,((Leiothrichidae_-Laughingthrushes_and_Allies:14.44884734,(Pellorneidae_-Ground_Babblers_and_Allies:11.7168913,Muscicapidae_-Old_World_Flycatchers:11.7168913):2.731956045):0.2372352419,Cisticolidae_-Cisticolas_and_Allies:14.68608259):1.466276993):1.165823893,(Pnoepygidae_-Cupwings:14.51991816,(Promeropidae_-Sugarbirds:12.31461439,Passeridae_-Old_World_Sparrows:12.31461439):2.205303771):2.798265313):0.7338928291):0.3809386676,Sylviidae_-Sylviid_Warblers:18.43301497):8.144991523):3.169678227):3.584973796,(Nicatoridae_-Nicators:31.58276753,(Panuridae_-Bearded_Reedling:27.70260322,Alaudidae_-Larks:27.70260322):3.880164318):1.749890978):5.131108066):5.529456735,((Regulidae_-Kinglets:42.86160025,(((Hypocoliidae_-Hypocolius:35.62162441,((Bombycillidae_-Waxwings:29.73287131,Hylocitreidae_-Hylocitrea:29.73287132):4.814157738,Ptiliogonatidae_-Silky-flycatchers:34.54702906):1.074595358):2.618070552,Dulidae_-Palmchat:38.23969497):1.911835425,((((Mimidae_-Mockingbirds_and_Thrashers:17.52322757,Sturnidae_-Starlings:17.52322756):0.2760865094,Buphagidae_-Oxpeckers:17.79931408):4.576244035,(Cinclidae_-Dippers:21.71271703,Turdidae_-Thrushes_and_Allies:21.71271703):0.6628410761):12.27217467,(((Certhiidae_-Treecreepers:22.36594503,Tichodromidae_-Wallcreeper:22.36594503):1.567378133,(Troglodytidae_-Wrens:21.68233144,Polioptilidae_-Gnatcatchers:21.68233144):2.25099172):4.634594153,Sittidae_-Nuthatches:28.56791732):6.079815462):5.503797612):2.710069854):0.2797502318,(((((Prunellidae_-Accentors:28.88435954,Peucedramidae_-Olive_Warbler:28.88435955):1.131532405,(Ploceidae_-Weavers_and_Allies:17.89955331,(Estrildidae_-Waxbills_and_Allies:17.35358358,Viduidae_-Indigobirds:17.35358358):0.5459697291):12.11633864):3.052896168,(Fringillidae_-Finches_Euphonias_and_Allies:29.32410005,((((Emberizidae_-Buntings_and_New_World_Sparrows:12.82188097,Icteridae_-Troupials_and_Allies:12.82188097):5.662296615,(Parulidae_-New_World_Warblers:17.18674558,Thraupidae_-Tanagers_and_Allies:17.18674558):1.297432008):6.302255307,Cardinalidae_-Cardinals_and_Allies:24.7864329):2.357254442,Calcariidae_-Longspurs_and_Snow_Buntings:27.14368733):2.180412711):3.744688074):4.191624147,((Chloropseidae_-Leafbirds:32.89114167,Irenidae_-Fairy-bluebirds:32.89114167):1.162154349,(Dicaeidae_-Flowerpeckers:26.64621208,Nectariniidae_-Sunbirds_and_Spiderhunters:26.64621207):7.407083947):3.207116243):2.585840701,Urocynchramidae_-Przevalski's_Pinktail:39.84625297):3.295097514):0.8518728334):2.029861676):1.310188158):3.658147385):1.739752565):2.959306969):1.580899478):3.53282316):6.775088177):2.709470473):5.619307455):1.607144298):0.2708515393):1.24399516):0.4976457369,(((Leptosomidae_-Cuckoo-Roller:78.12603751,(Trogonidae_-Trogons:76.18499648,(((Bucerotidae_-Hornbills:46.31064323,Bucorvidae_-Ground-Hornbills:46.31064323):19.22546689,(Phoeniculidae_-Woodhoopoes_and_Scimitar-bills:41.35304527,Upupidae_-Hoopoes:41.35304528):24.18306484):8.504170452,((Meropidae_-Bee-eaters:68.66570424,((Brachypteraciidae_-Ground-Rollers:55.85669797,Coraciidae_-Rollers:55.85669797):7.607807239,(Todidae_-Todies:56.17507256,(Alcedinidae_-Kingfishers:43.13126477,Momotidae_-Motmots:43.13126476):13.04380779):7.289432652):5.201199022):4.00364685,((Bucconidae_-Puffbirds:47.05733955,Galbulidae_-Jacamars:47.05733955):18.96073575,(((((Ramphastidae_-Toucans:18.26953301,Semnornithidae_-Toucan-Barbets:18.269533):1.88261942,Capitonidae_-New_World_Barbets:20.15215243):7.443714756,Lybiidae_-African_Barbets:27.59586718):0.9973124375,Megalaimidae_-Asian_Barbets:28.59317962):3.62347371,(Picidae_-Woodpeckers:30.20350816,Indicatoridae_-Honeyguides:30.20350816):2.013145169):33.80142196):6.65127579):1.370929486):2.144715914):1.941041024):0.2793452689,(Tytonidae_-Barn-Owls:60.89577497,Strigidae_-Owls:60.89577497):17.50960781):0.5466393304,(Cathartidae_-New_World_Vultures:77.64887225,((Accipitridae_-Hawks_Eagles_and_Kites:61.83891646,Pandionidae_-Osprey:61.83891646):5.294476942,Sagittariidae_-Secretary-bird:67.1333934):10.51547885):1.303149865):0.5756834371):1.639200266):0.5067798749):0.7134859488,(((Phaethontidae_-Tropicbirds:79.9897531,(((Otididae_-Bustards:66.16481904,Cuculidae_-Cuckoos:66.16481904):1.394604044,(((Rallidae_-Rails_Gallinules_and_Coots:34.17671384,Sarothruridae_-Flufftails:34.17671385):20.26471294,Heliornithidae_-Finfoots:54.44142679):0.2247970914,(Psophiidae_-Trumpeters:48.399523,(Aramidae_-Limpkin:25.97974773,Gruidae_-Cranes:25.97974773):22.41977527):6.266700887):12.8931992):10.5830155,(Musophagidae_-Turacos:76.72666518,(Gaviidae_-Loons:73.21915468,((((Diomedeidae_-Albatrosses:55.79735508,Hydrobatidae_-Storm-Petrels:55.79735507):5.887730684,Procellariidae_-Shearwaters_and_Petrels:61.68508576):7.364531761,Spheniscidae_-Penguins:69.04961753):4.006246527,(Ciconiidae_-Storks:65.67323943,(((Threskiornithidae_-Ibises_and_Spoonbills:60.53178695,Ardeidae_-Herons_Egrets_and_Bitterns:60.53178695):3.222114618,(Pelecanidae_-Pelicans:56.05281791,(Balaenicipitidae_-Shoebill:55.63653306,Scopidae_-Hamerkop:55.63653306):0.4162848537):7.701083658):1.869317565,(Fregatidae_-Frigatebirds:56.17034499,(Sulidae_-Boobies_and_Gannets:32.88591412,(Anhingidae_-Anhingas:29.24389233,Phalacrocoracidae_-Cormorants_and_Shags:29.24389233):3.642021797):23.28443087):9.452874147):0.05002029515):7.382624611):0.1632906348):3.507510503):1.415773404):1.84731452):0.3374694857,(Opisthocomidae_-Hoatzin:78.4274361,((Mesitornithidae_-Mesites:77.37462969,Columbidae_-Pigeons_and_Doves:77.37462968):0.753978682,Pteroclidae_-Sandgrouse:78.12860837):0.2988277392):1.899786486):1.663580054,(Phoenicopteridae_-Flamingos:56.27406127,Podicipedidae_-Grebes:56.27406127):25.71674137):0.3963689897):18.78925515):0.3235792715);","carnivora":"((Nandinia_binotata_ott1088403:0,((Arctogalidia_trivirgata_ott768505:0,Arctictis_binturong_ott768502:0,(Paradoxurus_hermaphrodites_ott6145674:0,Paradoxurus_hermaphroditus_ott1088400:0,Paradoxurus_zeylonensis_ott650612:0,Paradoxurus_jerdoni_ott581994:0)Paradoxurus_ott1088402:0,Paguma_larvata_ott397136:0,Macrogalidia_musschenbroekii_ott220532:0)Paradoxurinae_ott5686:0,(Chrotogale_owstoni_ott768508:0,Diplogale_hosei_ott583720:0,Hemigalus_derbyanus_ott194340:0,Cynogale_bennettii_ott126631:0)Hemigalinae_ott5685:0,((Prionodon_pardicolor_ott373467:0,Prionodon_linsang_ott194349:0)Prionodon_ott194342:0,((Leptailurus_serval_ott86170:0,(Prionailurus_rubiginosus_ott507541:0,Prionailurus_iriomotensis_ott418475:0,(Prionailurus_viverrinus_ott862641:0,(Prionailurus_bengalensis_bengalensis_ott5557509:0,Prionailurus_bengalensis_euptilurus_ott547362:0,Prionailurus_bengalensis_chinensis_ott198595:0)Prionailurus_bengalensis_ott280108:0):0,Prionailurus_planiceps_ott86166:0)Prionailurus_ott570215:0):0,((Neofelis_diardi_ott882766:0,Neofelis_nebulosa_nebulosa_ott882765:0)Neofelis_ott763018:0,(((Panthera_onca_mesembrina_ott735488:0,(Panthera_leo_leo_ott5557508:0,Panthera_leo_atrox_ott927561:0,Panthera_leo_bleyenberghi_ott825431:0,Panthera_leo_spelaea_ott798329:0,Panthera_leo_persica_ott547996:0,Panthera_leo_krugeri_ott371429:0)Panthera_leo_ott563151:0):0,(Panthera_pardus_fusca_ott600110:0,Panthera_pardus_japonensis_ott182670:0,Panthera_pardus_saxicolor_ott42320:0,Panthera_pardus_orientalis_ott42318:0)Panthera_pardus_ott42324:0):0,(Panthera_uncia_ott532117:0,(Panthera_tigris_jacksoni_ott575331:0,Panthera_tigris_amoyensis_ott449298:0,Panthera_tigris_sondaica_ott445492:0,Panthera_tigris_sumatrae_ott42316:0,Panthera_tigris_altaica_ott19403:0,Panthera_tigris_tigris_ott19399:0,Panthera_tigris_corbetti_ott19397:0)Panthera_tigris_ott42314:0):0)Panthera_ott563154:0):0)Felidae_ott563159:0):0,((Civettictis_civetta_ott768511:0,(Viverra_suricata_ott6145690:0,Viverra_nasua_ott6145689:0,Viverra_lutreola_ott6145688:0,Viverra_cristata_ott6145686:0,Viverra_capensis_ott6145685:0,Viverra_binotata_ott6145684:0,Viverra_civettina_ott3613145:0,Viverra_ichneumon_ott3613143:0,Viverra_tangalunga_ott561910:0,Viverra_zibetha_ott445401:0,Viverra_megaspila_ott373464:0)Viverra_ott561909:0,Viverricula_indica_ott194346:0,(Genetta_abyssinica_ott3613140:0,Genetta_tigrina_ott350016:0,Genetta_felina_ott194348:0,Genetta_genetta_ott194343:0,Genetta_servalina_ott159587:0,Genetta_thierryi_ott159586:0,Genetta_johnstoni_ott159585:0,Genetta_maculata_ott159579:0,Genetta_pardina_ott45855:0,Genetta_poensis_ott45853:0,Genetta_angolensis_ott45851:0,Genetta_cristata_ott45849:0,Genetta_victoriae_ott45847:0,Genetta_sp._schoutedeni_ott45846:0,Genetta_bourloni_ott45845:0)Genetta_ott211399:0)Viverrinae_ott5681:0,(((Proteles_cristata_ott5835567:0,Proteles_cristatus_ott563161:0)Proteles_ott397160:0,(Crocuta_crocuta_ott397157:0,(Parahyaena_brunnea_ott742313:0,(Hyaena_crocuta_ott3613175:0,Hyaena_spelaea_ott3613174:0,Hyaena_hyaena_ott383901:0)Hyaena_ott383900:0):0):0)Hyaenidae_ott397138:0,(((Cryptoprocta_ferox_ott768514:0,Eupleres_goudotii_ott527114:0)Euplerinae_ott527106:0,(Mungotictis_decemlineata_ott995905:0,(Galidictis_grandidieri_ott3613138:0,Galidictis_fasciata_ott556857:0)Galidictis_ott556854:0,(Salanoia_sp._SMF-2010_ott924479:0,Salanoia_concolor_ott527118:0)Salanoia_ott527120:0,(Galidia_elegans_dambrensis_ott617064:0,Galidia_elegans_occidentalis_ott263793:0,Galidia_elegans_elegans_ott44171:0)Galidia_elegans_ott86159:0)Galidiinae_ott1033556:0)Eupleridae_ott827269:0,(Dologale_dybowskii_ott3613299:0,Liberiictis_kuhni_ott901613:0,Rhynchogale_melleri_ott901607:0,Atilax_paludinosus_ott750141:0,(Crossarchus_ansorgei_nigricolor_ott5839529:0,Crossarchus_obscurus_ott1088410:0,Crossarchus_alexandri_ott858557:0,Crossarchus_platycephalus_ott706189:0)Crossarchus_ott1088412:0,(Bdeogale_jacksoni_ott3613281:0,Bdeogale_crassicauda_ott670220:0,Bdeogale_nigripes_ott670218:0)Bdeogale_ott670222:0,Paracynictis_selousi_ott415266:0,Cynictis_penicillata_ott363578:0,(Mungos_gambianus_ott3613278:0,Mungos_mungo_ott333729:0)Mungos_ott333728:0,(Galerella_ochracea_ott3613284:0,Galerella_flavescens_ott3613283:0,Galerella_sanguinea_ott750158:0,Galerella_pulverulenta_ott658638:0,Galerella_nigrata_ott252765:0)Galerella_ott111026:0,Ichneumia_albicauda_ott159576:0,(Herpestes_edwardsi_ott5835568:0,Herpestes_semitorquatus_ott3613295:0,Herpestes_javanicus_ott815154:0,Herpestes_edwardsii_ott770756:0,Herpestes_auropunctatus_ott752562:0,Herpestes_ichneumon_ott749636:0,Herpestes_vitticollis_ott650605:0,Herpestes_smithii_ott650603:0,Herpestes_brachyurus_ott650601:0,Herpestes_fuscus_ott650599:0,Herpestes_urva_ott121160:0)Herpestes_ott42306:0,(Herpestes_naso_ott858555:0,Helogale_hirtula_ott645182:0,Helogale_parvula_ott6940:0)Helogale_ott645209:0)Herpestidae_ott42311:0):0):0):0):0)Feliformia_ott827259:0,((Chrysocyon_brachyurus_ott837601:0,(Speothos_pacivorus_ott6145419:0,Speothos_venaticus_ott684074:0)Speothos_ott684073:0,Atelocynus_microtis_ott621172:0,(Dusicyon_avus_ott4117978:0,Dusicyon_australis_ott408359:0)Dusicyon_ott247345:0,(Lycalopex_sp._Fuegian_dog_ott4117979:0,Lycalopex_fulvipes_ott996573:0,Lycalopex_gymnocercus_ott839340:0,Lycalopex_culpaeus_ott776077:0,Lycalopex_griseus_ott776070:0,Lycalopex_vetulus_ott313153:0,Lycalopex_sechurae_ott313143:0)Lycalopex_ott839344:0,((Otocyon_megalotis_ott821973:0,((Urocyon_littoralis_dickeyi_ott5839545:0,Urocyon_littoralis_littoralis_ott5839544:0,Urocyon_littoralis_santarosae_ott5839543:0,Urocyon_littoralis_santacruzae_ott5839542:0,Urocyon_littoralis_clementae_ott5839541:0,Urocyon_littoralis_catalinae_ott5839540:0)Urocyon_littoralis_ott682591:0,Urocyon_cinereoargenteus_ott685113:0)Urocyon_ott264179:0):0,(Vulpes_minimus_ott6145431:0,Vulpes_environmental_sample_ott4941920:0,Vulpes_pallida_ott3612512:0,Vulpes_bengalensis_ott3612511:0,Vulpes_cana_ott996571:0,Vulpes_chama_ott821968:0,(Vulpes_vulpes_schrenckii_ott5925605:0,Vulpes_vulpes_montana_ott5223228:0,Vulpes_vulpes_japonica_ott815800:0)Vulpes_vulpes_ott821964:0,Vulpes_macrotis_zinseri_ott610095:0,Vulpes_lagopus_beringensis_ott609054:0,Vulpes_corsac_ott523960:0,Vulpes_rueppellii_ott419501:0,Vulpes_zerda_ott315465:0,Vulpes_velox_ott297455:0,Vulpes_ferrilata_ott110766:0)Vulpes_ott821970:0):0,(Nyctereutes_procyonoides_albus_ott5839546:0,Nyctereutes_procyonoides_koreensis_ott777177:0,Nyctereutes_procyonoides_viverrinus_ott341774:0,Nyctereutes_procyonoides_procyonoides_ott77889:0)Nyctereutes_procyonoides_ott949680:0,(Cerdocyon_thous_ott821960:0,(Canis_lupaster_ott6145386:0,Canis_dingo_ott6145383:0,Canis_antarticus_ott6145382:0,Canis_sp._KEB-2016_ott5925604:0,Canis_anthus_ott5835572:0,'Canis_sp._Belgium/36:0,'Canis_sp._Russia/33:0,Canis_environmental_sample_ott4941918:0,Canis_hyaena_ott3612505:0,Canis_spelaeus_ott3612504:0,Canis_lycaon_ott948004:0,Canis_simensis_ott752755:0,Canis_adustus_ott621176:0,Canis_mesomelas_elongae_ott576165:0,Canis_sp._CANInt1_ott470950:0,Canis_indica_ott346728:0,Canis_himalayensis_ott346723:0,(Canis_aureus_ott621168:0,Canis_latrans_ott247331:0):0,Canis_rufus_ott113383:0,(((Cuon_primaevus_ott6145398:0,Cuon_alpinus_lepturus_ott5340003:0)Cuon_ott837603:0,Lycaon_pictus_ott821953:0):0,(Canis_lupus_variabilis_ott5839539:0,Canis_lupus_arctos_ott5340002:0,Canis_lupus_campestris_ott4941916:0,Canis_lupus_lupaster_ott987895:0,Canis_lupus_lupus_ott883675:0,Canis_lupus_signatus_ott545727:0,Canis_lupus_labradorius_ott531973:0,Canis_lupus_dingo_ott380529:0,Canis_lupus_hodophilax_ott318630:0,Canis_lupus_mogollonensis_ott263524:0,Canis_lupus_familiaris_ott247333:0,Canis_lupus_desertorum_ott234374:0,Canis_lupus_hattai_ott83897:0,Canis_lupus_laniger_ott80830:0,Canis_lupus_baileyi_ott67371:0,Canis_lupus_chanco_ott47500:0,Canis_lupus_pallipes_ott47497:0)Canis_lupus_ott247341:0):0):0):0)Canidae_ott770319:0,((Ailuropoda_melanoleuca_qinlingensis_ott319802:0,(Tremarctos_ornatus_ott679667:0,(Melursus_ursinus_ott297463:0,((Helarctos_malayanus_ott679701:0,((Ursus_americanus_vancouveri_ott703636:0,Ursus_americanus_kermodei_ott703627:0,Ursus_americanus_carlottae_ott412598:0,Ursus_americanus_altifrontalis_ott412596:0,Ursus_americanus_cinnamomum_ott412580:0,Ursus_americanus_americanus_ott391593:0)Ursus_americanus_ott872577:0,(Ursus_thibetanus_ussuricus_ott602968:0,Ursus_thibetanus_mupinensis_ott602966:0,Ursus_thibetanus_formosanus_ott596440:0,Ursus_thibetanus_thibetanus_ott576254:0,Ursus_thibetanus_japonicus_ott300426:0)Ursus_thibetanus_ott872580:0):0):0,((Ursus_arctos_syriacus_ott1093032:0,Ursus_arctos_middendorffi_ott999436:0,Ursus_arctos_isabellinus_ott958762:0,Ursus_arctos_arctos_ott879522:0,Ursus_arctos_horribilis_ott350099:0)Ursus_arctos_ott872567:0,Ursus_maritimus_ott10732:0):0):0):0):0)Ursidae_ott297458:0,(Ailurus_fulgens_styani_ott638813:0,(((Nasuella_meridensis_ott1030928:0,Nasuella_olivacea_ott1030921:0)Nasuella_ott1030943:0,Potos_flavus_ott532115:0,((((Bassaricyon_medius_orinomus_ott5223232:0,Bassaricyon_medius_medius_ott5223231:0)Bassaricyon_medius_ott541339:0,Bassaricyon_neblina_neblina_ott5223230:0,Bassaricyon_sp._H021_ott1066592:0,Bassaricyon_beddardi_ott1023225:0,Bassaricyon_alleni_ott794090:0,Bassaricyon_sp._H018_ott541340:0,Bassaricyon_gabbii_gabbii_ott541338:0)Bassaricyon_ott178246:0,(Nasua_sp._LD-2015_ott5925608:0,Nasua_narica_ott736280:0,Nasua_nasua_rufa_ott348027:0)Nasua_ott348030:0):0,((Bassariscus_sumichrasti_ott794088:0,Bassariscus_astutus_ott685103:0)Bassariscus_ott685106:0,(Procyon_obscurus_ott6145586:0,Procyon_brachyurus_ott6145585:0,Procyon_environmental_sample_ott4941932:0,Procyon_pygmaeus_ott3612887:0,Procyon_cancrivorus_ott914060:0,Procyon_minor_ott914053:0,(Procyon_lotor_lotor_ott767278:0,Procyon_lotor_hirtus_ott244085:0,Procyon_lotor_pallidus_ott203417:0)Procyon_lotor_ott348040:0)Procyon_ott348029:0):0):0)Procyonidae_ott872571:0,(((Vormela_peregusna_ott1031807:0,(Ictonyx_libycus_ott5839531:0,Ictonyx_libyca_ott1061038:0,(Poecilogale_albinucha_ott415263:0,Ictonyx_striatus_ott111024:0):0):0):0,(Mustela_quoll_ott6145485:0,Mustela_lutreolina_ott3612707:0,Mustela_bison_ott3612704:0,Mustela_subpalmata_ott3612703:0,Mustela_kathiah_ott1075273:0,Mustela_itatsi_ott975082:0,'Mustela_sp._BOLD:0,Lyncodon_patagonicus_ott901933:NA,(Mustela_frenata_ott685101:NA,(Neovison_environmental_sample_ott4941897:NA,Neovison_macrodon_ott3612712:NA,Neovison_vison_ott310482:NA)Neovison_ott310487:NA):NA,Mustela_africana_ott275125:NA,Mustela_felipei_ott275123:NA,((Mustela_nudipes_ott378004:NA,Mustela_strigidorsa_ott273796:NA):NA,(Mustela_erminea_ott681184:NA,((Mustela_sibirica_ott549525:NA,(Mustela_lutreola_ott923105:NA,((Mustela_putorius_furo_ott923119:NA,Mustela_eversmannii_ott915607:NA):NA,Mustela_nigripes_ott541439:NA):NA):NA):NA,(Mustela_altaica_ott69264:NA,Mustela_nivalis_heptneri_ott39395:NA):NA):NA):NA):NA)Mustelinae_ott131160:0):0,(Eira_barbara_ott381140:NA,(Martes_gwatkinsii_ott3612688:NA,((Gulo_nagelii_anon_ott6145475:NA,Gulo_luscus_ott3612678:NA,Gulo_gulo_ott178247:NA)Gulo_ott752563:NA,(Martes_flavigula_ott213517:NA,(Martes_foina_ott348047:NA,((Martes_zibellina_linkouensis_ott5925606:NA,Martes_martes_ott532122:NA):NA,((Martes_melampus_tsuensis_ott719226:NA,Martes_melampus_melampus_ott719225:NA)Martes_melampus_ott681181:NA,(Martes_americana_atrata_ott5846389:NA,Martes_americana_sierrae_ott235244:NA,Martes_americana_nesophila_ott235242:NA,Martes_americana_humboldtensis_ott235240:NA,Martes_americana_caurina_ott80402:NA)Martes_americana_ott923116:NA):NA):NA):NA):NA):NA,Martes_pennanti_ott4697:NA):NA)Martinae_ott67323:NA):0):0):0):0)Caniformia_ott827263:0)Carnivora_ott44565;"}

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports = fetch;

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseNewick", function() { return parseNewick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "seen", function() { return seen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_taxonomy_eBird_clements_checklist_family__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_taxonomy_eBird_clements_checklist_family___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_taxonomy_eBird_clements_checklist_family__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_data_eBird_json_will__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_data_eBird_json_will___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_data_eBird_json_will__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_data_eBird_json_jim__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_data_eBird_json_jim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_data_eBird_json_jim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_data_eBird_json_corey__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_data_eBird_json_corey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_data_eBird_json_corey__);



var seen = __WEBPACK_IMPORTED_MODULE_0_taxonomy_eBird_clements_checklist_family___default.a.reduce(function (res, x) {
  res[x.fam] = x;
  return res;
}, {});




function assign(li, name) {
  li.forEach(function (x) {
    seen[x.Family][name] = x.seen_count;
  });
}
assign(__WEBPACK_IMPORTED_MODULE_1_data_eBird_json_will___default.a, 'will');
assign(__WEBPACK_IMPORTED_MODULE_2_data_eBird_json_jim___default.a, 'jim');
assign(__WEBPACK_IMPORTED_MODULE_3_data_eBird_json_corey___default.a, 'corey');

// <!-- A modified version of  https://github.com/jasondavies/newick.js -->
function parseNewick(s) {
  var ancestors = [];
  var tree = {};
  var tokens = s.split(/\s*(;|\(|\)|,|:)\s*/);
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    switch (token) {
      case '(':
        // new children
        var subtree = {};
        tree.children = [subtree];
        ancestors.push(tree);
        tree = subtree;
        break;
      case ',':
        // another branch
        subtree = {};
        ancestors[ancestors.length - 1].children.push(subtree);
        tree = subtree;
        break;
      case ')':
        // optional name next
        tree = ancestors.pop();
        break;
      case ':':
        // optional length next
        break;
      default:
        var x = tokens[i - 1];
        if (x === ')' || x === '(' || x === ',') {
          token = token.replace(/_/g, ' ');
          var name = token.replace(/ -.*/, '');
          if (name.match(/ ott[0-9]+$/)) {
            tree.ott = name.match(/ ott([0-9]+)$/)[2];
            name = name.replace(/ ott[0-9]+$/, '');
          }
          tree.name = name;
          if (seen[name]) {
            tree.sp_count = seen[name].sp_count;
            tree.will = seen[name].will ? seen[name].will : 0;
            tree.jim = seen[name].jim ? seen[name].jim : 0;
            tree.corey = seen[name].corey ? seen[name].corey : 0;
          }

          tree.common = token.replace(/.*?-/, '');
        } else if (x === ':') {
          tree.length = parseFloat(token);
        }
    }
  }
  return tree;
}


/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getRay(_ref, _ref2, _ref3) {
  var width = _ref.width,
      height = _ref.height;
  var x = _ref2.x,
      y = _ref2.y;
  var _ref3$xExtreme = _ref3.xExtreme,
      xExtreme = _ref3$xExtreme === undefined ? null : _ref3$xExtreme,
      _ref3$yExtreme = _ref3.yExtreme,
      yExtreme = _ref3$yExtreme === undefined ? null : _ref3$yExtreme;

  var firstRay = computeRay((width - x) / 2, xExtreme, Math.cos);
  var secondRay = computeRay((height - y) / 2, yExtreme, Math.sin);
  return Math.min(firstRay, secondRay);
}

function computeRay(space, extreme, trig) {
  if (!extreme) {
    return space;
  }
  var available = space - extreme.value;
  var angle = (extreme.x - 90) / 180 * Math.PI;
  return Math.abs(available / trig(angle));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  size: function size(tree, _ref4, _ref5, _ref6) {
    var width = _ref4.width,
        height = _ref4.height;
    var x = _ref5.x,
        y = _ref5.y;
    var last = _ref6.last;

    var ray = Math.min(width - x, height - y) / 2 - last;
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1);
    });
  },
  optimizeSize: function optimizeSize(tree, size, margin, extreme) {
    var ray = getRay(size, margin, extreme || {});
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1);
    });
  },
  transformNode: function transformNode(x, y) {
    var angle = (x - 90) / 180 * Math.PI;
    var radius = y;
    return [~~(radius * Math.cos(angle)), ~~(radius * Math.sin(angle))];
  },
  transformSvg: function transformSvg(svg, margin, _ref7) {
    var width = _ref7.width,
        height = _ref7.height;

    return svg.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  },
  updateTransform: function updateTransform(transform, margin, _ref8) {
    var width = _ref8.width,
        height = _ref8.height;

    return transform.translate(width / 2, height / 2);
  },
  getLine: function getLine(d3) {
    return d3.radialLine().radius(function (d) {
      return d.y;
    }).angle(function (d) {
      return d.x / 180 * Math.PI;
    });
  },
  transformText: function transformText(d, children) {
    return {
      x: d.x < 180 === !children ? 6 : -6,
      rotate: d.x < 180 ? d.x - 90 : d.x + 90,
      anchor: d.x < 180 === !children ? 'start' : 'end'
    };
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return anchorTodx; });
/* unused harmony export compareString */
/* unused harmony export compareNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return drawLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return findInParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return mapMany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeTextAndGraph; });
/* unused harmony export roundPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return translate; });
/* unused harmony export updateTexts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function anchorTodx(d, el) {
  if (d === 'middle') {
    return -el.getBBox().width / 2;
  } else if (d === 'end') {
    return -el.getBBox().width;
  }
  return 0;
}

/*  return 'M' + transformNode(source.x, source.y) +
    ' ' + transformNode(source.x, (source.y + target.y) / 2) +
    ' ' + transformNode(target.x, (source.y + target.y) / 2) +
    ' ' + transformNode(target.x, target.y)
*/
function drawLink(source, target, _ref) {
  var transformNode = _ref.transformNode;

  // ssource = transformNode(source.x, source.y)
  // target = transformNode(target.x, target.y)
  return linkStep(target.x, target.y, source.x, source.y);
}

function linkStep(startAngle, startRadius, endAngle, endRadius) {
  var c0 = Math.cos(startAngle = (startAngle - 90) / 180 * Math.PI);
  var s0 = Math.sin(startAngle);
  var c1 = Math.cos(endAngle = (endAngle - 90) / 180 * Math.PI);
  var s1 = Math.sin(endAngle);
  // move to this point
  var out = 'M' + startRadius * c0 + ',' + startRadius * s0;
  if (endAngle !== startAngle) {
    out += 'A' + startRadius + ',' + startRadius + ' 0 0 ' + (endAngle > startAngle ? 1 : 0) + ' ' + startRadius * c1 + ',' + startRadius * s1;
  }
  return out + 'L' + endRadius * c1 + ',' + endRadius * s1;
}

function compareString(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}

function compareNode(a, b, attribute) {
  if (a.height < b.height) {
    return 1;
  }
  if (a.height > b.height) {
    return -1;
  }
  return compareString(a.data[attribute], b.data[attribute]);
}

function findInParents(node, nodes) {
  if (nodes.indexOf(node) !== -1) {
    return node;
  }

  var parent = node.parent;
  return parent === null ? node : findInParents(parent, nodes);
}

function mapMany(arr, mapper) {
  return arr.reduce(function (prev, curr) {
    return prev.concat(mapper(curr));
  }, []);
}

function removeTextAndGraph(selection) {
  ['circle', 'text'].forEach(function (select) {
    selection.selectAll(select).remove();
  });
}

function roundPath(pathString) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return pathString.replace(/\d+\.\d+/g, function (s) {
    return parseFloat(s).toFixed(precision);
  });
}

function toPromise(transition) {
  var count = 0;
  var interrupted = false;
  transition.each(function () {
    return count++;
  });
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (count === 0) {
      resolve('ended');
      return;
    }
    var check = function check() {
      if (--count === 0) {
        resolve(interrupted ? 'interrupted' : 'ended');
      }
    };
    transition.on('end', check);
    transition.on('interrupt', function () {
      interrupted = true;
      check();
    });
  });
}

function translate(vector, _ref2) {
  var transformNode = _ref2.transformNode;

  return 'translate(' + transformNode(vector.x, vector.y) + ')';
}

function binarySearch(arr, left, right, value) {
  if (right < left) {
    return right;
  }

  var mid = Math.round(left + (right - left) / 2);
  if (arr(mid) === value) {
    return mid;
  }

  return arr(mid) > value ? binarySearch(arr, left, mid - 1, value) : binarySearch(arr, mid + 1, right, value);
}

function updateText(width) {
  var _this = this;

  var textString = this.textContent;
  var textLength = textString.length;
  if (this.getSubStringLength(0, textLength) <= width) {
    return;
  }

  var index = binarySearch(function (pos) {
    return _this.getSubStringLength(0, pos);
  }, 0, textLength - 3, width);
  this.textContent = textString.substring(0, index) + '...';
}

function updateTexts(selection, maxLength) {
  if (maxLength === -1) {
    return;
  }

  selection.each(function () {
    updateText.call(this, maxLength);
  });
}



/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  size: function size(tree, _size, margin, _ref) {
    var last = _ref.last,
        first = _ref.first;

    tree.size([_size.height - margin.y * 2, _size.width - margin.x * 2 - (last + first)]);
  },
  transformNode: function transformNode(x, y) {
    return y + ',' + x;
  },
  transformSvg: function transformSvg(svg, margin, size, _ref2) {
    var first = _ref2.first;

    return svg.attr('transform', 'translate(' + margin.x + first + ',' + margin.y + ')');
  },
  updateTransform: function updateTransform(transform, _ref3, size, _ref4) {
    var x = _ref3.x,
        y = _ref3.y;
    var first = _ref4.first;

    return transform.translate(x + first, y);
  },
  getLine: function getLine(d3) {
    return d3.line().x(function (d) {
      return d.data.x;
    }).y(function (d) {
      return d.data.y;
    });
  },
  transformText: function transformText(text, children) {
    return {
      x: !children ? 6 : -6,
      rotate: 0,
      anchor: !children ? 'start' : 'end'
    };
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tree__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tree___default.a; });




/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getRay(_ref, _ref2, _ref3) {
  var width = _ref.width,
      height = _ref.height;
  var x = _ref2.x,
      y = _ref2.y;
  var _ref3$xExtreme = _ref3.xExtreme,
      xExtreme = _ref3$xExtreme === undefined ? null : _ref3$xExtreme,
      _ref3$yExtreme = _ref3.yExtreme,
      yExtreme = _ref3$yExtreme === undefined ? null : _ref3$yExtreme;

  var firstRay = computeRay((width - x) / 2, xExtreme, Math.cos);
  var secondRay = computeRay((height - y) / 2, yExtreme, Math.sin);
  return Math.min(firstRay, secondRay);
}

function computeRay(space, extreme, trig) {
  if (!extreme) {
    return space;
  }
  var available = space - extreme.value;
  var angle = (extreme.x - 90) / 180 * Math.PI;
  return Math.abs(available / trig(angle));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  size: function size(tree, _ref4, _ref5, _ref6) {
    var width = _ref4.width,
        height = _ref4.height;
    var x = _ref5.x,
        y = _ref5.y;
    var last = _ref6.last;

    // const ray = Math.min(width - x, height - y) / 2 - last
    tree.size([360, 360]).separation(function (a, b) {
      return 1;
      // return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1)
    });
  },
  optimizeSize: function optimizeSize(tree, size, margin, extreme) {
    var ray = getRay(size, margin, extreme || {});
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth + 1 : 1);
    });
  },
  transformNode: function transformNode(x, y) {
    var angle = (x - 90) / 180 * Math.PI;
    var radius = y;
    return [~~(radius * Math.cos(angle)), ~~(radius * Math.sin(angle))];
  },
  transformSvg: function transformSvg(svg, margin, _ref7) {
    var width = _ref7.width,
        height = _ref7.height;

    return svg.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  },
  updateTransform: function updateTransform(transform, margin, _ref8) {
    var width = _ref8.width,
        height = _ref8.height;

    return transform.translate(width / 2, height / 2);
  },
  getLine: function getLine(d3) {
    return d3.line();
  },
  transformText: function transformText(d, children) {
    return {
      x: d.x < 180 === !children ? 6 : -6,
      rotate: d.x < 180 ? d.x - 90 : d.x + 90,
      anchor: d.x < 180 === !children ? 'start' : 'end'
    };
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_async_computed__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_async_computed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_async_computed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

window.introJS = __webpack_require__(81).introJs;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_async_computed___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PhyloTree__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PhyloTree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PhyloTree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyMenu__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MyMenu__);
//
//
//
//
//
//
//
//

// import FamilyTable from './components/FamilyTable'
// import OverTime from './components/OverTime'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    // FamilyTable,
    // OverTime,
    PhyloTree: __WEBPACK_IMPORTED_MODULE_0__components_PhyloTree___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_MyMenu___default.a
  }
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attribution'
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'my-header',
  props: ['main', 'sub'],
  computed: {
    link: function link() {
      return 'https://en.wikipedia.org/wiki/' + this.main;
    }
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'my-menu',
  methods: {
    tutorial: function tutorial() {
      window.introJS().start();
    }
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_d3_tree__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WikiSummary__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WikiSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WikiSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Attribution__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Attribution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Attribution__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tree_trees__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tree_trees___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tree_trees__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components




// Tree data

// think of a better name
var parseNewick = __webpack_require__(86);

var trees = {};
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5_tree_trees___default.a).forEach(function (x) {
  trees[x] = parseNewick.parseNewick(__WEBPACK_IMPORTED_MODULE_5_tree_trees___default.a[x]);
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'phylo-tree',
  data: function data() {
    return {
      treeData: trees.bird,
      selectedPerson: 'will',
      selectedLeaf: '',
      people: {
        sp_count: 0,
        corey: 0,
        jim: 0,
        will: 0
      },
      selectedTree: 'bird',
      seen: parseNewick.seen
    };
  },

  methods: {
    clicked: function clicked(x) {
      var d = this.seen[x.data.name];
      if (d) {
        this.people.sp_count = this.seen[x.data.name].sp_count;
        this.people.corey = x.data.corey;
        this.people.will = x.data.will;
        this.people.jim = x.data.jim;
      }

      this.$scrollTo('#summary');

      this.selectedLeaf = x.data.name;
    },
    recolor: function recolor(person) {
      this.selectedPerson = person;
    },
    notNullColor: function notNullColor(d) {
      return function (x) {
        return '#F00';
      };
      // d3.scaleOrdinal()
      //  .domain(['Bacteria', 'Eukaryota', 'Archaea'])
      //  .range(d3.schemeCategory10)
    }
  },
  watch: {
    selectedTree: function selectedTree(newValue) {
      this.selectedLeaf = '';
      this.treeData = trees[newValue];
    }
  },
  computed: {
    common: function common() {
      var d = this.seen[this.selectedLeaf];
      if (d) {
        var c = d.Family.match(/\((.*)\)/)[1];
        return 'Order: ' + d.Order + ', Common: ' + c;
      }
      return '';
    }
  },
  components: {
    tree: __WEBPACK_IMPORTED_MODULE_1__vue_d3_tree__["a" /* tree */],
    attribution: __WEBPACK_IMPORTED_MODULE_3__Attribution___default.a,
    WikiSummary: __WEBPACK_IMPORTED_MODULE_2__WikiSummary___default.a,
    myHeader: __WEBPACK_IMPORTED_MODULE_4__Header___default.a
  }
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wikijs__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wikijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wikijs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var wikiApi = __WEBPACK_IMPORTED_MODULE_0_wikijs___default()({ apiUrl: 'https://en.wikipedia.org/w/api.php' });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wiki-summary',
  props: ['selected'],
  watch: {
    selected: function selected() {
      this.loading = true;
    },
    imageUrl: function imageUrl() {
      var _this = this;

      console.log('image watch called');
      if (Array.isArray(this.imageUrl)) {
        var filtered = this.imageUrl.filter(function (img) {
          return img.match(new RegExp(_this.info.image + '$', 'i'));
        });
        if (filtered) {
          this.imageUrl = filtered.pop();
        }
      } else if (!this.imageUrl) {
        this.imageUrl = 'https://via.placeholder.com/400?text=No+Image+Found';
      }
    }
  },
  asyncComputed: {
    imageUrl: function imageUrl() {
      var _this2 = this;

      return wikiApi.page(this.selected).then(function (x) {
        return x.mainImage();
      }).catch(function (reason) {
        console.log('main image failed: ' + reason);
        return wikiApi.page(_this2.selected).then(function (page) {
          return page.images();
        });
      });
    },
    info: function info() {
      this.info = {};
      return wikiApi.page(this.selected).then(function (x) {
        return x.info();
      }).catch(function (reason) {
        console.log('page info failed' + reason);
      });
    },
    text: function text() {
      var vm = this;
      return wikiApi.page(this.selected).then(function (x) {
        vm.loading = false;
        return x.summary();
      }).catch(function () {
        vm.loading = false;
        return '';
      });
    }
  }
});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resize_directive__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resize_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_resize_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__euclidean_layout__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__circular_layout__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__radial_layout__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__d3_utils__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_hierarchy__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_scale_chromatic__ = __webpack_require__(181);




//
//
//
//










__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_9_d3__, __WEBPACK_IMPORTED_MODULE_10_d3_hierarchy__, __WEBPACK_IMPORTED_MODULE_11_d3_scale_chromatic__);

var _layout = {
  euclidean: __WEBPACK_IMPORTED_MODULE_5__euclidean_layout__["a" /* default */],
  circular: __WEBPACK_IMPORTED_MODULE_6__circular_layout__["a" /* default */],
  radial: __WEBPACK_IMPORTED_MODULE_7__radial_layout__["a" /* default */]
};

var i = 0;
var currentSelected = null;
var types = ['tree', 'cluster'];
var layouts = ['circular', 'euclidean', 'radial'];

var props = {
  data: Object,
  duration: {
    type: Number,
    default: 750
  },
  type: {
    type: String,
    default: 'tree',
    validator: function validator(value) {
      return types.indexOf(value) !== -1;
    }
  },
  layoutType: {
    type: String,
    default: 'euclidean',
    validator: function validator(value) {
      return layouts.indexOf(value) !== -1;
    }
  },
  color: {
    type: Function,
    default: __WEBPACK_IMPORTED_MODULE_9_d3__["scaleOrdinal"]().domain(['Bacteria', 'Eukaryota', 'Archaea']).range(__WEBPACK_IMPORTED_MODULE_9_d3__["schemeCategory10"])
  },
  marginX: {
    type: Number,
    default: 20
  },
  marginY: {
    type: Number,
    default: 20
  },
  nodeText: {
    type: String,
    required: true
  },
  person: {
    type: String,
    default: 'corey'
  },
  identifier: {
    type: Function,
    default: function _default() {
      return i++;
    }
  },
  ramp: { // color ramp used for vis, will work for one of these https://github.com/d3/d3-scale-chromatic
    String: String,
    default: 'interpolateYlGnBu'
  },
  zoomable: {
    type: Boolean,
    default: false
  }
};

var directives = {
  resize: __WEBPACK_IMPORTED_MODULE_4_vue_resize_directive___default.a
};

function hasChildren(d) {
  return d.children || d._children;
}

function getChildren(d) {
  return d.children ? { children: d.children, visible: true } : d._children ? { children: d._children, visible: false } : null;
}

function onAllChilddren(d, callback) {
  var fatherVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  if (callback(d, fatherVisible) === false) {
    return;
  }
  var directChildren = getChildren(d);
  directChildren && directChildren.children.forEach(function (child) {
    return onAllChilddren(child, callback, directChildren.visible);
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'D3Tree',

  props: props,

  directives: directives,

  data: function data() {
    return {
      currentTransform: null,
      maxTextLenght: {
        first: 0,
        last: 0
      }
    };
  },
  mounted: function mounted() {
    var size = this.getSize();
    var svg = __WEBPACK_IMPORTED_MODULE_9_d3__["select"](this.$el).append('svg').attr('width', size.width).attr('height', size.height);
    if (size.width === 400) {
      svg = svg.attr('viewBox', '-300 -270 1000 1000'); // kinda a hack to make it more usable on mobile devices
    }

    var g = null;
    var zoom = null;

    if (this.zoomable) {
      g = svg.append('g');
      zoom = __WEBPACK_IMPORTED_MODULE_9_d3__["zoom"]().scaleExtent([0.9, 8]).on('zoom', this.zoomed(g));
      svg.call(zoom).on('wheel', function () {
        return __WEBPACK_IMPORTED_MODULE_9_d3__["event"].preventDefault();
      });
      svg.call(zoom.transform, __WEBPACK_IMPORTED_MODULE_9_d3__["zoomIdentity"]);
    } else {
      g = this.transformSvg(svg.append('g'), size);
    }

    var tree = this.tree;
    this.internaldata = {
      svg: svg,
      g: g,
      tree: tree,
      zoom: zoom
    };

    this.data && this.onData(this.data);
  },


  methods: {
    getSize: function getSize() {
      var width = this.$el.clientWidth;
      var height = this.$el.clientHeight;
      return { width: width, height: height };
    },
    resize: function resize() {
      var size = this.getSize();
      this.internaldata.svg.attr('width', size.width).attr('height', size.height);
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      this.applyZoom(size);
      this.redraw();
    },
    completeRedraw: function completeRedraw(_ref) {
      var _ref$margin = _ref.margin,
          margin = _ref$margin === undefined ? null : _ref$margin,
          _ref$layout = _ref.layout,
          layout = _ref$layout === undefined ? null : _ref$layout;

      var size = this.getSize();
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      this.applyTransition(size, { margin: margin, layout: layout });
      this.redraw();
    },
    transformSvg: function transformSvg(g, size) {
      size = size || this.getSize();
      return this.layout.transformSvg(g, this.margin, size, this.maxTextLenght);
    },
    updateTransform: function updateTransform(g, size) {
      size = size || this.getSize();
      return this.layout.updateTransform(g, this.margin, size, this.maxTextLenght);
    },
    updateGraph: function updateGraph(source) {
      var _this = this;

      var originBuilder = source;
      var forExit = source;
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        var origin = { x: source.x0, y: source.y0 };
        originBuilder = function originBuilder(d) {
          return origin;
        };
        forExit = function forExit(d) {
          return { x: source.x, y: source.y };
        };
      }

      var root = this.internaldata.root;
      var links = this.internaldata.g.selectAll('.linktree').data(this.internaldata.tree(root).descendants().slice(1), function (d) {
        return d.id;
      });

      var updateLinks = links.enter().append('path').attr('class', 'linktree');
      var node = this.internaldata.g.selectAll('.nodetree').data(root.descendants(), function (d) {
        return d.id;
      });
      var newNodes = node.enter().append('g').attr('class', 'nodetree');
      var allNodes = newNodes.merge(node);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["a" /* removeTextAndGraph */])(node);

      var text = allNodes.append('text').attr('dy', '.35em').text(function (d) {
        if (!d.data[_this.nodeText].match(/ subclade/)) {
          // removes labels that are subclades
          return d.data[_this.nodeText];
        }
      }).on('click', function (d) {
        currentSelected = currentSelected === d ? null : d;
        _this.mouseovered(false)(d);
        __WEBPACK_IMPORTED_MODULE_9_d3__["event"].stopPropagation();
        _this.redraw();
        _this.$emit('clicked', { element: d, data: d.data });
      }).on('mouseover', this.mouseovered(true)).on('mouseout', this.mouseovered(false));

      // branch coloring
      updateLinks.each(function (d) {
        d.linkExtensionNode = this;
      }).attr('d', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["b" /* drawLink */])(originBuilder(d), originBuilder(d), _this.layout);
      }).attr('stroke', function (x) {
        return x.color ? x.color : '#555';
      });

      var updateAndNewLinks = links.merge(updateLinks);
      var updateAndNewLinksPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["c" /* toPromise */])(updateAndNewLinks.transition().duration(this.duration).attr('d', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["b" /* drawLink */])(d, d.parent, _this.layout);
      }));

      var exitingLinksPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["c" /* toPromise */])(links.exit().transition().duration(this.duration).attr('d', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["b" /* drawLink */])(forExit(d), forExit(d), _this.layout);
      }).remove());

      newNodes.attr('transform', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["d" /* translate */])(originBuilder(d), _this.layout);
      });

      allNodes.classed('node--internal', function (d) {
        return hasChildren(d);
      }).classed('node--leaf', function (d) {
        return !hasChildren(d);
      }).classed('selected', function (d) {
        return d === currentSelected;
      }).on('click', this.onNodeClick);

      var allNodesPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["c" /* toPromise */])(allNodes.transition().duration(this.duration).attr('transform', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["d" /* translate */])(d, _this.layout);
      }).attr('opacity', 1));
      // the outter circle
      // this is where we color the nodes
      allNodes.append('circle').attr('fill', function (d) {
        return __WEBPACK_IMPORTED_MODULE_9_d3__[_this.ramp](d.data[_this.person] / d.data.sp_count);
      });

      text.attr('x', function (d) {
        return d.textInfo ? d.textInfo.x : 0;
      }).attr('dx', function (d) {
        return d.textInfo ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["e" /* anchorTodx */])(d.textInfo.anchor, this) : 0;
      }).attr('transform', function (d) {
        return 'rotate(' + (d.textInfo ? d.textInfo.rotate : 0) + ')';
      });

      var transformText = this.layout.transformText;

      allNodes.each(function (d) {
        d.textInfo = transformText(d, hasChildren(d));
      });

      var textTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["c" /* toPromise */])(text.transition().duration(this.duration).attr('x', function (d) {
        return d.textInfo.x;
      }).attr('dx', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["e" /* anchorTodx */])(d.textInfo.anchor, this);
      }).attr('transform', function (d) {
        return 'rotate(' + d.textInfo.rotate + ')';
      }));

      allNodes.each(function (d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });

      var exitingNodes = node.exit();
      var exitingNodesPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["c" /* toPromise */])(exitingNodes.transition().duration(this.duration).attr('transform', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["d" /* translate */])(forExit(d), _this.layout);
      }).attr('opacity', 0).remove());
      exitingNodes.select('circle').attr('r', 1e6);

      var leaves = root.leaves();
      var extremeNodes = text.filter(function (d) {
        return leaves.indexOf(d) !== -1;
      }).nodes();
      var last = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(extremeNodes.map(function (node) {
        return node.getComputedTextLength();
      }))) + 6;
      var first = text.node().getComputedTextLength() + 6;
      if (last <= this.maxTextLenght.last && first <= this.maxTextLenght.first) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([allNodesPromise, exitingNodesPromise, textTransition, updateAndNewLinksPromise, exitingLinksPromise]);
      }

      this.maxTextLenght = { first: first, last: last };
      var size = this.getSize();
      if (this.zoomable) {
        this.internaldata.svg.call(this.internaldata.zoom.transform, this.currentTransform);
      } else {
        var g = this.internaldata.g;

        this.transformSvg(g, size);
      }
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      return this.updateGraph(source);
    },
    onNodeClick: function onNodeClick(d) {
      if (d.children) {
        this.collapse(d);
      } else {
        this.expand(d);
      }
    },
    setColor: function setColor(d) {
      var name = d.data.name;
      d.color = this.color.domain().indexOf(name) >= 0 ? this.color(name) : d.parent ? d.parent.color : null;
      if (d.children) d.children.forEach(this.setColor);
    },
    onData: function onData(data) {
      var _this2 = this;

      if (!data) {
        this.internaldata.root = null;
        this.clean();
        return;
      }
      var root = __WEBPACK_IMPORTED_MODULE_9_d3__["hierarchy"](data).sum(function (x) {
        return x.children ? 0 : 1;
      }).sort(function (a, b) {
        return a.length - b.length || __WEBPACK_IMPORTED_MODULE_9_d3__["ascending"](a.data.length, b.data.length);
        // return compareString(a.data.length, b.data.length)
      });
      this.internaldata.root = root;
      root.each(function (d) {
        d.id = _this2.identifier(d.data);
      });
      var size = this.getSize();
      root.x = size.height / 2;
      root.y = 0;
      root.x0 = root.x;
      root.y0 = root.y;
      this.setColor(root);
      this.redraw();
    },
    clean: function clean() {
      var _this3 = this;

      ['.linktree', '.nodetree', 'text', 'circle'].forEach(function (selector) {
        _this3.internaldata.g.selectAll(selector).transition().duration(_this3.duration).attr('opacity', 0).remove();
      });
    },
    redraw: function redraw() {
      var root = this.internaldata.root;
      if (root) {
        return this.updateGraph(root);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('no graph');
    },
    getNodeOriginComputer: function getNodeOriginComputer(originalVisibleNodes) {
      return function (node) {
        var parentVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["f" /* findInParents */])(node, originalVisibleNodes);
        return { x: parentVisible.x0, y: parentVisible.y0 };
      };
    },
    applyZoom: function applyZoom(size) {
      var _internaldata = this.internaldata,
          g = _internaldata.g,
          zoom = _internaldata.zoom;

      if (this.zoomable) {
        g.call(zoom.transform, this.currentTransform);
      } else {
        this.transformSvg(g, size);
      }
    },
    applyTransition: function applyTransition(size, _ref2) {
      var margin = _ref2.margin,
          layout = _ref2.layout;
      var _internaldata2 = this.internaldata,
          g = _internaldata2.g,
          svg = _internaldata2.svg,
          zoom = _internaldata2.zoom;

      if (this.zoomable) {
        var transform = this.currentTransform;
        var oldMargin = margin || this.margin;
        var oldLayout = layout || this.layout;

        var nowTransform = oldLayout.updateTransform(transform, oldMargin, size, this.maxTextLenght);
        var nextRealTransform = this.updateTransform(transform, size);
        var current = __WEBPACK_IMPORTED_MODULE_9_d3__["zoomIdentity"].translate(transform.x + nowTransform.x - nextRealTransform.x, transform.y + nowTransform.y - nextRealTransform.y).scale(transform.k);

        svg.call(zoom.transform, current).transition().duration(this.duration).call(zoom.transform, transform);
      } else {
        var transitiong = g.transition().duration(this.duration);
        this.transformSvg(transitiong, size);
      }
    },
    mouseovered: function mouseovered(active) {
      return function (d) {
        __WEBPACK_IMPORTED_MODULE_9_d3__["select"](this).classed('label-active', active);
        __WEBPACK_IMPORTED_MODULE_9_d3__["select"](d.linkExtensionNode).classed('link-active', active);
        d = d.parent;
        while (d) {
          __WEBPACK_IMPORTED_MODULE_9_d3__["select"](d.linkExtensionNode).classed('link-active', active);
          d = d.parent;
        }
        // d3.select(d.linkExtensionNode).classed("link-extension--active", active).each(this.moveToFront)
      };
    },
    zoomed: function zoomed(g) {
      var _this4 = this;

      return function () {
        var transform = __WEBPACK_IMPORTED_MODULE_9_d3__["event"].transform;
        var size = _this4.getSize();
        var transformToApply = _this4.updateTransform(transform, size);
        _this4.currentTransform = transform;
        _this4.$emit('zoom', { transform: transform });
        g.attr('transform', transformToApply);
      };
    },
    updateIfNeeded: function updateIfNeeded(d, update) {
      return update ? this.updateGraph(d).then(function () {
        return true;
      }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
    },


    // API
    collapse: function collapse(d) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!d.children) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }

      d._children = d.children;
      d.children = null;
      this.$emit('retract', { element: d, data: d.data });
      return this.updateIfNeeded(d, update);
    },
    expand: function expand(d) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!d._children) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }

      d.children = d._children;
      d._children = null;
      this.$emit('expand', { element: d, data: d.data });
      return this.updateIfNeeded(d, update);
    },
    expandAll: function expandAll(d) {
      var _this5 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var lastVisible = d.leaves();
      onAllChilddren(d, function (child) {
        _this5.expand(child, false);
      });
      return this.updateIfNeeded(this.getNodeOriginComputer(lastVisible), update);
    },
    collapseAll: function collapseAll(d) {
      var _this6 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      onAllChilddren(d, function (child) {
        return _this6.collapse(child, false);
      });
      return this.updateIfNeeded(d, update);
    },
    show: function show(d) {
      var _this7 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var path = d.ancestors().reverse();
      var root = path.find(function (node) {
        return node.children === null;
      }) || d;
      path.forEach(function (node) {
        return _this7.expand(node, false);
      });
      return this.updateIfNeeded(root, update);
    },
    showOnly: function showOnly(d) {
      var _this8 = this;

      var root = this.internaldata.root;
      var path = d.ancestors().reverse();
      var shouldBeRetracted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["g" /* mapMany */])(path, function (p) {
        return p.children ? p.children : [];
      }).filter(function (node) {
        return node && path.indexOf(node) === -1;
      });
      var mapped = {};
      shouldBeRetracted.filter(function (node) {
        return node.children;
      }).forEach(function (rectractedNode) {
        return rectractedNode.each(function (c) {
          mapped[c.id] = rectractedNode;
        });
      });
      var origin = function origin(node) {
        var reference = mapped[node.id];
        return { x: reference.x, y: reference.y };
      };
      var updater = function updater(node) {
        if (shouldBeRetracted.indexOf(node) !== -1) {
          _this8.collapse(node, false);
          return false;
        }
        return node !== d;
      };
      onAllChilddren(root, updater);
      return this.updateGraph(origin).then(function () {
        return true;
      });
    },
    resetZoom: function resetZoom() {
      if (!this.zoomable) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      var _internaldata3 = this.internaldata,
          svg = _internaldata3.svg,
          zoom = _internaldata3.zoom;

      var transitionPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["c" /* toPromise */])(svg.transition().duration(this.duration).call(zoom.transform, function () {
        return __WEBPACK_IMPORTED_MODULE_9_d3__["zoomIdentity"];
      }));
      return transitionPromise.then(function () {
        return true;
      });
    }
  },

  computed: {
    tree: function tree() {
      var size = this.getSize();
      var tree = this.type === 'cluster' ? __WEBPACK_IMPORTED_MODULE_9_d3__["cluster"]() : __WEBPACK_IMPORTED_MODULE_9_d3__["tree"]();
      this.layout.size(tree, size, this.margin, this.maxTextLenght);
      return tree;
    },
    margin: function margin() {
      return { x: this.marginX, y: this.marginY };
    },
    layout: function layout() {
      return _layout[this.layoutType];
    }
  },

  watch: {
    data: function data(current, old) {
      this.onData(current);
    },
    type: function type() {
      if (!this.internaldata.tree) {
        return;
      }
      this.internaldata.tree = this.tree;
      this.redraw();
    },
    person: function person() {
      if (!this.internaldata.tree) {
        return;
      }
      this.redraw();
    },
    marginX: function marginX(newMarginX, oldMarginX) {
      this.completeRedraw({ margin: { x: oldMarginX, y: this.marginY } });
    },
    marginY: function marginY(newMarginY, oldMarginY) {
      this.completeRedraw({ margin: { x: this.marginX, y: oldMarginY } });
    },
    layout: function layout(newLayout, oldLayout) {
      this.completeRedraw({ layout: oldLayout });
    }
  }
});

/***/ })

},[92]);


// WEBPACK FOOTER //
// static/js/app.4bff88846a2677c9a426.js